(function () {
  var INFO_ICON = [
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">',
    '<circle cx="9" cy="9" r="7.125" stroke="currentColor" stroke-width="1.5"></circle>',
    '<path d="M9 8.125V12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>',
    '<path d="M9 5.5C9.41421 5.5 9.75 5.83579 9.75 6.25C9.75 6.66421 9.41421 7 9 7C8.58579 7 8.25 6.66421 8.25 6.25C8.25 5.83579 8.58579 5.5 9 5.5Z" fill="currentColor"></path>',
    "</svg>",
  ].join("");
  var CHECK_ICON = [
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">',
    '<path d="M5.5 10.25L8.125 12.875L14.5 6.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>',
    "</svg>",
  ].join("");
  var CHEVRON_ICON = [
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">',
    '<path d="M4.5 11.25L9 6.75L13.5 11.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
    "</svg>",
  ].join("");
  var SOURCE_ROOT_SELECTOR =
    "#simple-bundles-io-options, .simple-bundles-io-options";
  var RUNTIME_CONTRACT_VERSION = 1;

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalizeKey(value, options) {
    var settings = options || {};
    var nextValue = String(value || "")
      .trim()
      .toLowerCase();

    if (settings.stripSelectPrefix !== false) {
      nextValue = nextValue.replace(/^select\s+/, "");
    }

    if (settings.stripColorPrefix === true) {
      nextValue = nextValue.replace(/^color\s+/, "");
    }

    return nextValue.replace(/[^a-z0-9]/g, "");
  }

  function stripOptionSuffix(value) {
    return String(value || "")
      .replace(/\s*\([^)]+\)\s*$/, "")
      .trim();
  }

  function stripColorPrefix(value) {
    return String(value || "")
      .replace(/^color\s+/i, "")
      .trim();
  }

  function createPriceFormatter(sampleText) {
    var sample = String(sampleText || "").trim();
    var firstDigitIndex = sample.search(/\d/);
    var lastDigitMatch = sample.match(/\d(?!.*\d)/);
    var lastDigitIndex = lastDigitMatch
      ? sample.lastIndexOf(lastDigitMatch[0])
      : -1;
    var prefix = firstDigitIndex > 0 ? sample.slice(0, firstDigitIndex) : "";
    var suffix = lastDigitIndex > -1 ? sample.slice(lastDigitIndex + 1) : "";
    var numericPart = (
      firstDigitIndex > -1 && lastDigitIndex > -1
        ? sample.slice(firstDigitIndex, lastDigitIndex + 1)
        : "0.00"
    ).replace(/\s/g, "");
    var separators = numericPart.match(/[^\d]/g) || [];
    var decimalSeparator =
      separators.length > 0 ? separators[separators.length - 1] : ".";
    var decimalParts = numericPart.split(decimalSeparator);
    var decimals =
      decimalParts.length > 1
        ? decimalParts[decimalParts.length - 1].length
        : 0;
    var integerPartSample = decimalParts[0] || "0";
    var thousandsSeparatorMatch = integerPartSample.match(/[^\d]/);
    var thousandsSeparator = thousandsSeparatorMatch
      ? thousandsSeparatorMatch[0]
      : ",";
    var subunitDivisor = Math.pow(10, decimals);

    function formatPrice(value) {
      var numericValue = Number(value || 0);
      var isNegative = numericValue < 0;
      var absoluteValue = Math.abs(numericValue);
      var fixed = absoluteValue.toFixed(decimals);
      var fixedParts = fixed.split(".");
      var integerPart = fixedParts[0];
      var decimalPart = fixedParts[1] || "";
      var groupedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousandsSeparator,
      );
      var formatted = groupedInteger;

      if (decimals > 0) {
        formatted += decimalSeparator + decimalPart;
      }

      return (isNegative ? "-" : "") + prefix + formatted + suffix;
    }

    formatPrice.subunitDivisor = subunitDivisor;

    return formatPrice;
  }

  function parseGroupConfig(section) {
    var script = section.querySelector("[data-bundle-option-groups-config]");

    if (!script) {
      return [];
    }

    try {
      return JSON.parse(script.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function parseConfiguratorRuntime(section) {
    var script = section.querySelector("[data-configurator-runtime]");

    if (!script) {
      return null;
    }

    try {
      var parsed = JSON.parse(script.textContent || "null");

      if (
        !parsed ||
        typeof parsed !== "object" ||
        parsed.v !== RUNTIME_CONTRACT_VERSION ||
        typeof parsed.rev !== "number" ||
        !Array.isArray(parsed.groups)
      ) {
        return null;
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function parseConfiguratorCountry(section) {
    return String(section.getAttribute("data-country") || "")
      .trim()
      .toUpperCase();
  }

  function parseBundlePresetParams() {
    if (
      typeof window === "undefined" ||
      !window.location ||
      !window.location.search ||
      typeof window.URLSearchParams !== "function"
    ) {
      return {};
    }

    var presetMap = {};
    var params = new window.URLSearchParams(window.location.search);

    params.forEach(function (value, key) {
      var normalizedKey = normalizeKey(key);

      if (!normalizedKey) {
        return;
      }

      if (!presetMap[normalizedKey]) {
        presetMap[normalizedKey] = [];
      }

      presetMap[normalizedKey].push(value);
    });

    return presetMap;
  }

  function shouldLogBundlePresetDebug() {
    if (
      typeof window === "undefined" ||
      !window.location ||
      !window.location.search ||
      typeof window.URLSearchParams !== "function"
    ) {
      return false;
    }

    var params = new window.URLSearchParams(window.location.search);

    return (
      params.get("bundle_debug") === "1" ||
      params.get("bundle-debug") === "1" ||
      params.has("bundle_debug") ||
      params.has("bundle-debug")
    );
  }

  function toReadablePresetToken(value, options) {
    var settings = options || {};
    var nextValue = String(value || "")
      .trim()
      .toLowerCase();

    if (settings.stripSelectPrefix !== false) {
      nextValue = nextValue.replace(/^select\s+/, "");
    }

    if (settings.stripColorPrefix === true) {
      nextValue = nextValue.replace(/^color\s+/, "");
    }

    return nextValue
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getBundleLabels(section) {
    return {
      learnMore:
        section.getAttribute("data-bundle-label-learn-more") || "Learn More",
      comparisonItem:
        section.getAttribute("data-bundle-label-comparison-item") || "Option",
      takeoff:
        section.getAttribute("data-bundle-label-experience-takeoff") ||
        "Takeoff",
      stability:
        section.getAttribute("data-bundle-label-experience-stability") ||
        "Stability",
      speed:
        section.getAttribute("data-bundle-label-experience-speed") || "Speed",
      turning:
        section.getAttribute("data-bundle-label-experience-turning") ||
        "Turning",
      bestFor:
        section.getAttribute("data-bundle-label-experience-best-for") ||
        "Best for",
      tooltipEnabled: {
        takeoff:
          section.getAttribute("data-experience-tooltip-takeoff-enabled") ===
          "true",
        stability:
          section.getAttribute(
            "data-experience-tooltip-stability-enabled",
          ) === "true",
        speed:
          section.getAttribute("data-experience-tooltip-speed-enabled") ===
          "true",
        turning:
          section.getAttribute("data-experience-tooltip-turning-enabled") ===
          "true",
      },
      sizeGuide:
        section.getAttribute("data-bundle-label-size-guide") || "Size Guide",
      size: section.getAttribute("data-bundle-label-size") || "Size",
      sizeChartHeading:
        section.getAttribute("data-bundle-label-size-chart-heading") ||
        "Size Info",
      sizeChartColSize:
        section.getAttribute("data-bundle-label-size-chart-col-size") ||
        "Size",
      sizeChartColEu:
        section.getAttribute("data-bundle-label-size-chart-col-eu") ||
        "EU size",
      sizeChartColSizeCm:
        section.getAttribute("data-bundle-label-size-chart-col-size-cm") ||
        "Size cm",
      sizeChartColSizeIn:
        section.getAttribute("data-bundle-label-size-chart-col-size-in") ||
        "Size in",
      sizeChartColHeight:
        section.getAttribute("data-bundle-label-size-chart-col-height") ||
        "Height cm",
      sizeChartColHeightIn:
        section.getAttribute("data-bundle-label-size-chart-col-height-in") ||
        "Height in",
      sizeChartColChest:
        section.getAttribute("data-bundle-label-size-chart-col-chest") ||
        "Chest cm",
      sizeChartColChestIn:
        section.getAttribute("data-bundle-label-size-chart-col-chest-in") ||
        "Chest in",
      sizeChartColAdjustable:
        section.getAttribute("data-bundle-label-size-chart-col-adjustable") ||
        "Adjustable",
      specificationsHeading:
        section.getAttribute("data-bundle-label-specifications-heading") ||
        "Specifications",
      includedShowAll:
        section.getAttribute("data-bundle-label-included-show-all") ||
        "Show All",
      includedShowLess:
        section.getAttribute("data-bundle-label-included-show-less") ||
        "Show Less",
      specificationsOpenByDefault:
        section.getAttribute("data-bundle-specifications-open") === "true",
    };
  }

  function buildGroupConfigMap(configs) {
    return (configs || []).reduce(function (result, config) {
      if (!config) {
        return result;
      }

      [
        normalizeKey(config.key, {
          stripSelectPrefix: false,
        }),
        normalizeKey(config.option_name),
        normalizeKey(config.heading),
      ].forEach(function (key) {
        if (key && !result[key]) {
          result[key] = config;
        }
      });

      return result;
    }, {});
  }

  function getSourceGroups(sourceRoot) {
    if (!sourceRoot) {
      return [];
    }

    return Array.prototype.slice
      .call(sourceRoot.querySelectorAll('select[name^="properties["]'))
      .filter(function (select) {
        return select.dataset.bundleBoardIgnore !== "true";
      })
      .map(function (select) {
        var labels = Array.prototype.slice.call(
          sourceRoot.querySelectorAll("label"),
        );
        var labelNode = labels.find(function (label) {
          return label.getAttribute("for") === select.id;
        });
        var labelText = labelNode ? labelNode.textContent.trim() : "";
        var propertyName = (select.getAttribute("name") || "")
          .replace(/^properties\[/, "")
          .replace(/\]$/, "");

        return {
          select: select,
          labelNode: labelNode,
          label: labelText || propertyName,
          propertyName: propertyName,
          options: Array.prototype.slice.call(select.options || []),
        };
      });
  }

  function getMeaningfulSourceOptions(sourceGroup) {
    return ((sourceGroup && sourceGroup.options) || []).filter(function (
      optionNode,
    ) {
      if (!optionNode || !optionNode.value || optionNode.disabled) {
        return false;
      }

      return !/please select/i.test(optionNode.text || "");
    });
  }

  function getRenderableSourceOptions(sourceGroup, groupConfig) {
    var meaningfulOptions = getMeaningfulSourceOptions(sourceGroup).filter(
      function (optionNode) {
        return !isSourceOptionMarketHidden(optionNode, groupConfig);
      },
    );

    if (isGroupHiddenFromUi(groupConfig) || !hasCards(groupConfig)) {
      return meaningfulOptions;
    }

    return meaningfulOptions.filter(function (optionNode) {
      return !isCardHiddenFromUi(
        findMatchingCard(groupConfig ? groupConfig.cards : [], optionNode.value),
      );
    });
  }

  function getDefaultVisibleSourceOption(renderedGroup) {
    var sourceGroup = renderedGroup && renderedGroup.group;
    var groupConfig = renderedGroup && renderedGroup.groupConfig;
    var options = (sourceGroup && sourceGroup.options) || [];
    var fallbackVisibleOption = null;
    var defaultVisibleOption = null;

    options.some(function (optionNode) {
      var cardConfig = null;
      var isHiddenCard = false;

      if (!optionNode || !optionNode.value || optionNode.disabled) {
        return false;
      }

      if (/please select/i.test(optionNode.text || "")) {
        return false;
      }

      if (isSourceOptionMarketHidden(optionNode, groupConfig)) {
        return false;
      }

      cardConfig = findMatchingCard(
        groupConfig ? groupConfig.cards : [],
        optionNode.value,
      );
      isHiddenCard = isCardHiddenFromUi(cardConfig);

      if (isHiddenCard) {
        return false;
      }

      if (!fallbackVisibleOption) {
        fallbackVisibleOption = optionNode;
      }

      if (normalizeBoolean(cardConfig && cardConfig.default_selected)) {
        defaultVisibleOption = optionNode;
        return true;
      }

      return false;
    });

    return defaultVisibleOption || fallbackVisibleOption;
  }

  function getSourceGroupsSignature(sourceGroups) {
    return (sourceGroups || [])
      .map(function (group) {
        var select = group && group.select;
        var options = Array.prototype.slice.call(
          (select && select.options) || group.options || [],
        );

        return [
          normalizeKey(group && group.propertyName, {
            stripSelectPrefix: false,
          }),
          normalizeKey(group && group.label, {
            stripSelectPrefix: false,
          }),
          String((select && select.value) || ""),
          options
            .map(function (optionNode) {
              return [
                String((optionNode && optionNode.value) || ""),
                String((optionNode && optionNode.text) || ""),
                optionNode && optionNode.disabled ? "1" : "0",
                optionNode && optionNode.selected ? "1" : "0",
              ].join("::");
            })
            .join("||"),
        ].join("###");
      })
      .join("@@@");
  }

  function getGroupConfig(group, configMap) {
    var match = null;

    [normalizeKey(group.propertyName), normalizeKey(group.label)].some(
      function (key) {
        if (key && configMap[key]) {
          match = configMap[key];
          return true;
        }

        return false;
      },
    );

    return match;
  }

  function findMatchingCard(cards, optionValue) {
    var normalizedValue = normalizeKey(optionValue, { stripColorPrefix: true });
    var normalizedKeyValue = normalizeKey(optionValue, {
      stripColorPrefix: false,
      stripSelectPrefix: false,
    });

    return (
      (cards || []).find(function (card) {
        return (
          getCardKey(card) === normalizedKeyValue ||
          normalizeKey(card.option_value, { stripColorPrefix: true }) ===
          normalizedValue
        );
      }) || null
    );
  }

  function hasCards(groupConfig) {
    return !!(groupConfig && groupConfig.cards && groupConfig.cards.length);
  }

  function inferRenderType(groupConfig) {
    var explicitType = String((groupConfig && groupConfig.render_type) || "")
      .trim()
      .toLowerCase();

    if (
      explicitType === "swatch" ||
      explicitType === "pill" ||
      explicitType === "card"
    ) {
      return explicitType;
    }

    if (hasCards(groupConfig)) {
      return "card";
    }

    return "pill";
  }

  function getDisplayLabel(optionValue, renderType) {
    var label = stripOptionSuffix(optionValue);

    if (renderType === "swatch") {
      return stripColorPrefix(label);
    }

    return label;
  }

  function getSwatchColor(cardConfig) {
    return (cardConfig && cardConfig.swatch_color) || "var(--ui-color-surface-tertiary)";
  }

  function inferSelectionType(groupConfig) {
    return String((groupConfig && groupConfig.selection_type) || "single")
      .trim()
      .toLowerCase() === "multiple"
      ? "multiple"
      : "single";
  }

  function isGroupHiddenFromUi(groupConfig) {
    return normalizeBoolean(groupConfig && groupConfig.hide_from_ui);
  }

  function isCardHiddenFromUi(cardConfig) {
    return normalizeBoolean(cardConfig && cardConfig.hide_from_ui);
  }

  // Cards not offered in the current market are dropped from `cards` in Liquid and listed in
  // `market_hidden_cards`, so legacy app selects can drop the matching options as well.
  // A visible card with the same value wins (US-only and non-US cards may share an option_value).
  function isSourceOptionMarketHidden(optionNode, groupConfig) {
    var marketHiddenCards =
      groupConfig && Array.isArray(groupConfig.market_hidden_cards)
        ? groupConfig.market_hidden_cards
        : [];

    if (!optionNode || !optionNode.value || !marketHiddenCards.length) {
      return false;
    }

    if (findMatchingCard(groupConfig.cards, optionNode.value)) {
      return false;
    }

    return !!findMatchingCard(marketHiddenCards, optionNode.value);
  }

  function getGroupConfigKeys(groupConfig) {
    var keys = [];

    [
      groupConfig && groupConfig.key,
      groupConfig && groupConfig.option_name,
      groupConfig && groupConfig.heading,
    ].forEach(function (value) {
      var nextKey = normalizeKey(value);

      if (nextKey && keys.indexOf(nextKey) === -1) {
        keys.push(nextKey);
      }
    });

    return keys;
  }

  function getSourceGroupKeys(group) {
    var keys = [];

    [group && group.propertyName, group && group.label].forEach(
      function (value) {
        var nextKey = normalizeKey(value);

        if (nextKey && keys.indexOf(nextKey) === -1) {
          keys.push(nextKey);
        }
      },
    );

    return keys;
  }

  function pushUniqueKeys(target, keys) {
    (keys || []).forEach(function (key) {
      if (key && target.indexOf(key) === -1) {
        target.push(key);
      }
    });
  }

  function getCardKey(cardConfig) {
    return normalizeKey(
      (cardConfig &&
        (cardConfig.key || cardConfig.option_value || cardConfig.title)) ||
        "",
      {
        stripColorPrefix:
          !(
            cardConfig &&
            cardConfig.key &&
            String(cardConfig.key || "").trim() !== ""
          ),
      },
    );
  }

  function getCardHandle(cardConfig) {
    var rawHandle = String((cardConfig && cardConfig.handle) || "").trim();

    if (rawHandle) {
      return normalizeKey(rawHandle, {
        stripSelectPrefix: false,
      });
    }

    return getCardKey(cardConfig);
  }

  function getVisibleCards(cards, activeOptionValue) {
    var activeCardKey = normalizeKey(activeOptionValue, {
      stripColorPrefix: true,
    });

    return (cards || []).filter(function (card) {
      if (!isCardHiddenFromUi(card)) {
        return true;
      }

      return !!activeCardKey && getCardKey(card) === activeCardKey;
    });
  }

  function findCardByKey(cards, cardKey) {
    return (
      (cards || []).find(function (card) {
        return getCardKey(card) === cardKey;
      }) || null
    );
  }

  function getCardPresetMatchValue(cardConfig) {
    return (cardConfig && (cardConfig.option_value || cardConfig.title)) || "";
  }

  function getCardPresetMatchSource(cardConfig) {
    if (cardConfig && cardConfig.option_value) {
      return "option_value";
    }

    return "title";
  }

  function getEntryPresetKeys(entry) {
    var keys = [];

    pushUniqueKeys(keys, getGroupConfigKeys(entry && entry.groupConfig));
    pushUniqueKeys(keys, getSourceGroupKeys(entry && entry.group));

    return keys;
  }

  function getPresetValues(presetMap, presetKeys) {
    return (presetKeys || []).reduce(function (result, key) {
      if (!presetMap || !presetMap[key]) {
        return result;
      }

      return result.concat(presetMap[key]);
    }, []);
  }

  function splitPresetValues(values) {
    return (values || []).reduce(function (result, value) {
      String(value == null ? "" : value)
        .split(",")
        .forEach(function (part) {
          var nextValue = String(part || "").trim();

          if (nextValue) {
            result.push(nextValue);
          }
        });

      return result;
    }, []);
  }

  function getSourceOptionPresetKeys(optionNode) {
    var keys = [];

    [optionNode && optionNode.value, optionNode && optionNode.text].forEach(
      function (value) {
        var nextKey = normalizeKey(value, { stripColorPrefix: true });

        if (nextKey && keys.indexOf(nextKey) === -1) {
          keys.push(nextKey);
        }
      },
    );

    return keys;
  }

  function findSourceOptionByPreset(sourceGroup, presetValues, groupConfig) {
    var options = (sourceGroup && sourceGroup.options) || [];
    var presetTokens = splitPresetValues(presetValues);
    var matchedOption = null;

    presetTokens.some(function (token) {
      var tokenKey = normalizeKey(token, { stripColorPrefix: true });

      if (!tokenKey) {
        return false;
      }

      matchedOption =
        options.find(function (optionNode) {
          if (!optionNode || !optionNode.value || optionNode.disabled) {
            return false;
          }

          if (isSourceOptionMarketHidden(optionNode, groupConfig)) {
            return false;
          }

          return getSourceOptionPresetKeys(optionNode).indexOf(tokenKey) !== -1;
        }) || null;

      return !!matchedOption;
    });

    return matchedOption;
  }

  function parseMultiplePresetToken(value) {
    var rawValue = String(value == null ? "" : value).trim();
    var clearKey = normalizeKey(rawValue);
    var tokenMatch = rawValue.match(/^([^:|]+)[:|](.+)$/);
    var cardValue = tokenMatch ? tokenMatch[1] : rawValue;
    var sizeValue = tokenMatch ? tokenMatch[2] : "";

    if (!rawValue) {
      return null;
    }

    if (
      clearKey === "none" ||
      clearKey === "false" ||
      clearKey === "off" ||
      clearKey === "0"
    ) {
      return {
        clearAll: true,
        cardKey: "",
        sizeValue: "",
        sizeKey: "",
      };
    }

    return {
      clearAll: false,
      cardKey: normalizeKey(cardValue, { stripColorPrefix: true }),
      sizeValue: String(sizeValue || "").trim(),
      sizeKey: normalizeKey(sizeValue),
    };
  }

  function normalizeBoolean(value) {
    var normalizedValue = String(value == null ? "" : value)
      .trim()
      .toLowerCase();

    return (
      normalizedValue === "true" ||
      normalizedValue === "1" ||
      normalizedValue === "yes" ||
      normalizedValue === "on"
    );
  }

  function getAddOnProduct(cardConfig) {
    return (cardConfig && cardConfig.product) || null;
  }

  function getAddOnVariants(cardConfig) {
    var product = getAddOnProduct(cardConfig);

    return (product && product.variants) || [];
  }

  function getAddOnDefaultVariant(cardConfig) {
    var variants = getAddOnVariants(cardConfig);

    for (var index = 0; index < variants.length; index += 1) {
      if (variants[index] && variants[index].available) {
        return variants[index];
      }
    }

    return variants[0] || null;
  }

  function getAddOnSizeChoices(cardConfig) {
    var seenKeys = {};

    return getAddOnVariants(cardConfig).reduce(function (result, variant) {
      var sizeValue = String((variant && variant.size_value) || "").trim();
      var sizeKey = normalizeKey(sizeValue);

      if (!sizeValue || !sizeKey) {
        return result;
      }

      if (!seenKeys[sizeKey]) {
        seenKeys[sizeKey] = {
          key: sizeKey,
          value: sizeValue,
          available: !!variant.available,
          variantId: String((variant && variant.id) || ""),
          price: Number((variant && variant.price) || 0),
        };
        result.push(seenKeys[sizeKey]);
        return result;
      }

      if (!seenKeys[sizeKey].available && variant.available) {
        seenKeys[sizeKey].available = true;
        seenKeys[sizeKey].variantId = String((variant && variant.id) || "");
        seenKeys[sizeKey].price = Number((variant && variant.price) || 0);
      }

      return result;
    }, []);
  }

  function getAddOnChoiceFromSize(cardConfig, sizeValue) {
    var normalizedSizeValue = normalizeKey(sizeValue);
    var sizeChoices = getAddOnSizeChoices(cardConfig);

    return (
      sizeChoices.find(function (choice) {
        return choice.key === normalizedSizeValue;
      }) || null
    );
  }

  function getDefaultAddOnChoice(cardConfig) {
    var sizeChoices = getAddOnSizeChoices(cardConfig);
    var firstAvailableSizeChoice =
      sizeChoices.find(function (choice) {
        return choice.available;
      }) ||
      sizeChoices[0] ||
      null;

    if (firstAvailableSizeChoice) {
      return {
        variantId: firstAvailableSizeChoice.variantId,
        sizeValue: firstAvailableSizeChoice.value,
        price: firstAvailableSizeChoice.price,
      };
    }

    var defaultVariant = getAddOnDefaultVariant(cardConfig);

    if (!defaultVariant) {
      return null;
    }

    return {
      variantId: String(defaultVariant.id || ""),
      sizeValue: "",
      price: Number(defaultVariant.price || 0),
    };
  }

  function findAddOnVariantById(cardConfig, variantId) {
    return (
      getAddOnVariants(cardConfig).find(function (variant) {
        return (
          String((variant && variant.id) || "") === String(variantId || "")
        );
      }) || null
    );
  }

  function getSelectedAddOnVariant(cardConfig, selection) {
    var selectedVariant =
      selection && selection.variantId
        ? findAddOnVariantById(cardConfig, selection.variantId)
        : null;

    return selectedVariant || getAddOnDefaultVariant(cardConfig);
  }

  function getPriceFormatterSubunitDivisor(priceFormatter) {
    var divisor = Number(
      priceFormatter && priceFormatter.subunitDivisor
        ? priceFormatter.subunitDivisor
        : 100,
    );

    if (isNaN(divisor) || divisor <= 0) {
      return 100;
    }

    return divisor;
  }

  function convertSubunitsToDisplayUnits(rawValue, priceFormatter) {
    var numericValue = Number(rawValue || 0);

    if (isNaN(numericValue)) {
      return 0;
    }

    return numericValue / getPriceFormatterSubunitDivisor(priceFormatter);
  }

  function getOptionDatasetNumber(optionNode, key) {
    if (!optionNode || !optionNode.dataset) {
      return NaN;
    }

    var rawValue = optionNode.dataset[key];

    if (rawValue == null || rawValue === "") {
      return NaN;
    }

    return Number(rawValue);
  }

  function isParentVariantBundleGroup(sourceGroup, productOptionNames) {
    var sourceGroupKeys = getSourceGroupKeys(sourceGroup);

    return (productOptionNames || []).some(function (optionName) {
      return sourceGroupKeys.indexOf(normalizeKey(optionName || "")) !== -1;
    });
  }

  function getSingleOptionLinkedVariant(cardConfig) {
    return getAddOnDefaultVariant(cardConfig);
  }

  function getSingleOptionLinkedPrice(cardConfig) {
    var linkedVariant = getSingleOptionLinkedVariant(cardConfig);
    var linkedPrice = linkedVariant ? Number(linkedVariant.price || 0) : NaN;

    return isNaN(linkedPrice) ? NaN : linkedPrice;
  }

  function shouldTreatSingleGroupAsDelta(renderedGroup, hasParentBasePrice) {
    var sourceGroup = renderedGroup && renderedGroup.group;
    var options = getMeaningfulSourceOptions(sourceGroup);
    var defaultOption = getDefaultVisibleSourceOption(renderedGroup);
    var defaultPrice = defaultOption
      ? getOptionDatasetNumber(defaultOption, "price")
      : NaN;
    var hasNonZeroPriceDiff = options.some(function (optionNode) {
      var priceDiff = getOptionDatasetNumber(optionNode, "priceDiff");

      return !isNaN(priceDiff) && priceDiff !== 0;
    });

    if (hasNonZeroPriceDiff) {
      return true;
    }

    // When the parent variant already carries the bundle total, single-option
    // groups should only contribute deltas from the default included component.
    if (hasParentBasePrice && defaultOption) {
      return true;
    }

    if (isNaN(defaultPrice) || defaultPrice !== 0) {
      return false;
    }

    return options.some(function (optionNode) {
      if (defaultOption && optionNode === defaultOption) {
        return false;
      }

      var optionPrice = getOptionDatasetNumber(optionNode, "price");

      return !isNaN(optionPrice) && optionPrice > 0;
    });
  }

  function getLegacyOptionPriceMarkup(optionNode, priceFormatter) {
    var priceDiff = getOptionDatasetNumber(optionNode, "priceDiff");

    if (!isNaN(priceDiff) && priceDiff !== 0) {
      return (priceDiff > 0 ? "+" : "-") + priceFormatter(Math.abs(priceDiff));
    }

    var absolutePrice = getOptionDatasetNumber(optionNode, "price");

    if (!isNaN(absolutePrice) && absolutePrice > 0) {
      return "+" + priceFormatter(absolutePrice);
    }

    return "";
  }

  function getSingleGroupMarketAwareValue(
    optionNode,
    cardConfig,
    renderedGroup,
    hasParentBasePrice,
  ) {
    var linkedPrice = getSingleOptionLinkedPrice(cardConfig);

    if (isNaN(linkedPrice)) {
      return NaN;
    }

    if (!shouldTreatSingleGroupAsDelta(renderedGroup, hasParentBasePrice)) {
      return linkedPrice;
    }

    var groupConfig = renderedGroup && renderedGroup.groupConfig;
    var defaultOption = getDefaultVisibleSourceOption(renderedGroup);
    var defaultCardConfig = defaultOption
      ? findMatchingCard(groupConfig ? groupConfig.cards : [], defaultOption.value)
      : null;
    var defaultLinkedPrice = getSingleOptionLinkedPrice(defaultCardConfig);

    if (isNaN(defaultLinkedPrice)) {
      return NaN;
    }

    return linkedPrice - defaultLinkedPrice;
  }

  function syncSingleGroupPriceLabels(
    groupRoot,
    renderedGroup,
    priceFormatter,
    productOptionNames,
    hasParentBasePrice,
    options,
  ) {
    var settings = options || {};
    var sourceGroup = renderedGroup && renderedGroup.group;
    var groupConfig = renderedGroup && renderedGroup.groupConfig;

    Array.prototype.slice
      .call(groupRoot.querySelectorAll("[data-bundle-option-button]"))
      .forEach(function (button) {
        var optionValue = button.getAttribute("data-bundle-value") || "";
        var sourceOption =
          (sourceGroup && sourceGroup.options
            ? sourceGroup.options.find(function (optionNode) {
                return String((optionNode && optionNode.value) || "") === String(optionValue);
              })
            : null) || null;
        var cardConfig = findMatchingCard(
          groupConfig ? groupConfig.cards : [],
          optionValue,
        );
        var priceNode = button.querySelector(
          ".product-page-section__bundle-card-price",
        );

        if (!priceNode) {
          return;
        }

        if (
          settings.isPublishedConfigurator &&
          typeof settings.getPublishedPriceMarkup === "function"
        ) {
          priceNode.textContent = settings.getPublishedPriceMarkup(
            groupConfig,
            cardConfig,
          );
          return;
        }

        priceNode.textContent = getOptionPriceMarkup(
          sourceOption,
          cardConfig,
          renderedGroup,
          priceFormatter,
          productOptionNames,
          hasParentBasePrice,
        );
      });
  }

  function hasAvailableAddOnChoice(cardConfig) {
    return !!getDefaultAddOnChoice(cardConfig);
  }

  function getAddOnSizeChart(cardConfig) {
    return (cardConfig && cardConfig.size_chart) || null;
  }

  function hasAddOnSizeChart(cardConfig) {
    var sizeChart = getAddOnSizeChart(cardConfig);
    var sizeChoices = getAddOnSizeChoices(cardConfig);
    var hasRows =
      Array.isArray(sizeChart && sizeChart.rows) && sizeChart.rows.length > 0;
    var hasContent =
      String((sizeChart && sizeChart.content_html) || "").trim() !== "";

    return sizeChoices.length > 1 && !!sizeChart && (hasRows || hasContent);
  }

  function normalizeSizeChartCellValue(value) {
    return String(value == null ? "" : value).trim();
  }

  function formatSizeChartAdjustableValue(value) {
    if (value === false || value == null) {
      return "";
    }

    var normalizedValue = normalizeSizeChartCellValue(value);

    if (!normalizedValue || /^(false|0|no)$/i.test(normalizedValue)) {
      return "";
    }

    if (/^(true|1|yes)$/i.test(normalizedValue)) {
      return "Yes";
    }

    return normalizedValue;
  }

  function getSizeChartVisibleColumns(rows) {
    var visibleColumns = {
      size: true,
      eu_size: false,
      size_cm: false,
      size_in: false,
      height: false,
      height_in: false,
      chest: false,
      chest_in: false,
      adjustable: false,
    };

    (rows || []).forEach(function (row) {
      if (normalizeSizeChartCellValue(row && row.eu_size)) {
        visibleColumns.eu_size = true;
      }

      if (normalizeSizeChartCellValue(row && row.size_cm)) {
        visibleColumns.size_cm = true;
      }

      if (normalizeSizeChartCellValue(row && row.size_in)) {
        visibleColumns.size_in = true;
      }

      if (normalizeSizeChartCellValue(row && row.height)) {
        visibleColumns.height = true;
      }

      if (normalizeSizeChartCellValue(row && row.height_in)) {
        visibleColumns.height_in = true;
      }

      if (normalizeSizeChartCellValue(row && row.chest)) {
        visibleColumns.chest = true;
      }

      if (normalizeSizeChartCellValue(row && row.chest_in)) {
        visibleColumns.chest_in = true;
      }

      if (formatSizeChartAdjustableValue(row && row.adjustable)) {
        visibleColumns.adjustable = true;
      }
    });

    return visibleColumns;
  }

  function renderAddOnSizeChartTable(sizeChart, labels) {
    var rows = Array.isArray(sizeChart && sizeChart.rows) ? sizeChart.rows : [];

    if (!rows.length) {
      return "";
    }

    var visibleColumns = getSizeChartVisibleColumns(rows);

    return [
      '<div class="product-page-section__size-chart-table-wrap">',
      '<table class="product-page-section__size-chart-table">',
      "<thead><tr>",
      visibleColumns.size
        ? '<th data-size-chart-column="size">' +
          escapeHtml((labels && labels.sizeChartColSize) || "Size") +
          "</th>"
        : "",
      visibleColumns.eu_size
        ? '<th data-size-chart-column="eu_size">' +
          escapeHtml((labels && labels.sizeChartColEu) || "EU size") +
          "</th>"
        : "",
      visibleColumns.size_cm
        ? '<th data-size-chart-column="size_cm">' +
          escapeHtml((labels && labels.sizeChartColSizeCm) || "Size cm") +
          "</th>"
        : "",
      visibleColumns.size_in
        ? '<th data-size-chart-column="size_in">' +
          escapeHtml((labels && labels.sizeChartColSizeIn) || "Size in") +
          "</th>"
        : "",
      visibleColumns.height
        ? '<th data-size-chart-column="height">' +
          escapeHtml((labels && labels.sizeChartColHeight) || "Height cm") +
          "</th>"
        : "",
      visibleColumns.height_in
        ? '<th data-size-chart-column="height_in">' +
          escapeHtml((labels && labels.sizeChartColHeightIn) || "Height in") +
          "</th>"
        : "",
      visibleColumns.chest
        ? '<th data-size-chart-column="chest">' +
          escapeHtml((labels && labels.sizeChartColChest) || "Chest cm") +
          "</th>"
        : "",
      visibleColumns.chest_in
        ? '<th data-size-chart-column="chest_in">' +
          escapeHtml((labels && labels.sizeChartColChestIn) || "Chest in") +
          "</th>"
        : "",
      visibleColumns.adjustable
        ? '<th data-size-chart-column="adjustable">' +
          escapeHtml(
            (labels && labels.sizeChartColAdjustable) || "Adjustable",
          ) +
          "</th>"
        : "",
      "</tr></thead>",
      "<tbody>",
      rows
        .map(function (row) {
          var adjustableValue = formatSizeChartAdjustableValue(
            row && row.adjustable,
          );

          return [
            '<tr data-size-chart-row data-size-chart-size="',
            escapeHtml(normalizeSizeChartCellValue(row && row.size)),
            '">',
            visibleColumns.size
              ? '<td data-size-chart-column="size">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.size)) +
                "</td>"
              : "",
            visibleColumns.eu_size
              ? '<td data-size-chart-column="eu_size">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.eu_size)) +
                "</td>"
              : "",
            visibleColumns.size_cm
              ? '<td data-size-chart-column="size_cm">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.size_cm)) +
                "</td>"
              : "",
            visibleColumns.size_in
              ? '<td data-size-chart-column="size_in">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.size_in)) +
                "</td>"
              : "",
            visibleColumns.height
              ? '<td data-size-chart-column="height">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.height)) +
                "</td>"
              : "",
            visibleColumns.height_in
              ? '<td data-size-chart-column="height_in">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.height_in)) +
                "</td>"
              : "",
            visibleColumns.chest
              ? '<td data-size-chart-column="chest">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.chest)) +
                "</td>"
              : "",
            visibleColumns.chest_in
              ? '<td data-size-chart-column="chest_in">' +
                escapeHtml(normalizeSizeChartCellValue(row && row.chest_in)) +
                "</td>"
              : "",
            visibleColumns.adjustable
              ? '<td data-size-chart-column="adjustable">' +
                escapeHtml(adjustableValue) +
                "</td>"
              : "",
            "</tr>",
          ].join("");
        })
        .join(""),
      "</tbody></table></div>",
    ].join("");
  }

  function getAddOnPriceMarkup(cardConfig, selection, priceFormatter) {
    var selectedVariant = getSelectedAddOnVariant(cardConfig, selection);
    var variantPrice = selectedVariant ? Number(selectedVariant.price || 0) : 0;

    if (isNaN(variantPrice) || variantPrice <= 0) {
      return "";
    }

    return "+" + priceFormatter(variantPrice);
  }

  function getAddOnCardImageUrl(cardConfig) {
    var product = getAddOnProduct(cardConfig);

    return (
      (cardConfig && cardConfig.image_url) ||
      (product && product.image_url) ||
      ""
    );
  }

  function getCardGalleryImages(cardConfig) {
    return Array.isArray(cardConfig && cardConfig.gallery_images)
      ? cardConfig.gallery_images
      : [];
  }

  function appendUniqueGalleryMedia(result, seen, media, fallbackAlt) {
    var source = String(
      (media && (media.src || media.url || media.image_url || media.imageUrl)) ||
        "",
    ).trim();

    if (!source) {
      return;
    }

    var dedupeKey = String(
      (media && (media.key || media.id || media.media_id)) || source,
    ).trim() || source;

    if (seen[dedupeKey] || seen[source]) {
      return;
    }

    seen[dedupeKey] = true;
    seen[source] = true;

    result.push({
      key: dedupeKey,
      src: source,
      thumbSrc: String(
        (media && (media.thumb_src || media.thumbSrc)) || source,
      ).trim() || source,
      lightboxSrc: String(
        (media && (media.lightbox_src || media.lightboxSrc)) || source,
      ).trim() || source,
      alt: String((media && media.alt) || fallbackAlt || "").trim(),
    });
  }

  function collectCardGalleryMedia(cardConfig) {
    var fallbackAlt =
      (cardConfig && (cardConfig.title || cardConfig.option_value)) || "";
    var galleryMedia = [];
    var seen = {};

    getCardGalleryImages(cardConfig).forEach(function (media) {
      appendUniqueGalleryMedia(galleryMedia, seen, media, fallbackAlt);
    });

    if (!galleryMedia.length) {
      var fallbackImageUrl = getAddOnCardImageUrl(cardConfig);

      if (fallbackImageUrl) {
        appendUniqueGalleryMedia(
          galleryMedia,
          seen,
          {
            key: fallbackImageUrl,
            src: fallbackImageUrl,
            thumbSrc: fallbackImageUrl,
            lightboxSrc: fallbackImageUrl,
          },
          fallbackAlt,
        );
      }
    }

    return galleryMedia;
  }

  function getCardIncludedImageUrl(cardConfig) {
    var explicitIncludedImageUrl = String(
      (cardConfig &&
        (cardConfig.included_image_url || cardConfig.includedImageUrl)) ||
        "",
    ).trim();

    if (explicitIncludedImageUrl) {
      return explicitIncludedImageUrl;
    }

    var galleryMedia = collectCardGalleryMedia(cardConfig);
    var firstGalleryItem = galleryMedia[0] || null;

    return String(
      (firstGalleryItem &&
        (firstGalleryItem.thumbSrc || firstGalleryItem.src)) ||
        "",
    ).trim();
  }

  function appendCardGalleryMedia(result, seen, cardConfig) {
    collectCardGalleryMedia(cardConfig).forEach(function (media) {
      appendUniqueGalleryMedia(result, seen, media, media.alt);
    });
  }

  function getCardModel3dUrl(cardConfig) {
    var modelUrl =
      cardConfig && (cardConfig.model_3d_url || cardConfig.model3dUrl);

    return typeof modelUrl === "string" ? modelUrl.trim() : "";
  }

  function getOptionPriceMarkup(
    optionNode,
    cardConfig,
    renderedGroup,
    priceFormatter,
    productOptionNames,
    hasParentBasePrice,
  ) {
    if (!optionNode) {
      return "";
    }

    if (
      isParentVariantBundleGroup(
        renderedGroup && renderedGroup.group,
        productOptionNames,
      )
    ) {
      return "";
    }

    var marketAwareValue = getSingleGroupMarketAwareValue(
      optionNode,
      cardConfig,
      renderedGroup,
      hasParentBasePrice,
    );

    if (!isNaN(marketAwareValue) && marketAwareValue !== 0) {
      return (
        (marketAwareValue > 0 ? "+" : "-") +
        priceFormatter(Math.abs(marketAwareValue))
      );
    }

    if (!isNaN(marketAwareValue)) {
      return "";
    }

    if (optionNode.dataset.priceDisplayed !== "true") {
      return "";
    }

    return getLegacyOptionPriceMarkup(optionNode, priceFormatter);
  }

  function renderCardDetails(cardConfig) {
    var details = [];

    if (
      cardConfig &&
      (cardConfig.detail_1_label || cardConfig.detail_1_value)
    ) {
      details.push(
        '<span class="product-page-section__bundle-card-detail">' +
          '<span class="product-page-section__bundle-card-detail-label">' +
          escapeHtml(cardConfig.detail_1_label || "") +
          "</span>" +
          '<span class="product-page-section__bundle-card-detail-value">' +
          escapeHtml(cardConfig.detail_1_value || "") +
          "</span>" +
          "</span>",
      );
    }

    if (
      cardConfig &&
      (cardConfig.detail_2_label || cardConfig.detail_2_value)
    ) {
      details.push(
        '<span class="product-page-section__bundle-card-detail">' +
          '<span class="product-page-section__bundle-card-detail-label">' +
          escapeHtml(cardConfig.detail_2_label || "") +
          "</span>" +
          '<span class="product-page-section__bundle-card-detail-value">' +
          escapeHtml(cardConfig.detail_2_value || "") +
          "</span>" +
          "</span>",
      );
    }

    if (!details.length) {
      return "";
    }

    return (
      '<span class="product-page-section__bundle-card-details">' +
      details.join("") +
      "</span>"
    );
  }

  function cardHasExperienceData(cardConfig) {
    return !!(
      cardConfig &&
      (cardConfig.experience_takeoff ||
        cardConfig.experience_stability ||
        cardConfig.experience_speed ||
        cardConfig.experience_turning ||
        cardConfig.experience_best_for)
    );
  }

  function groupHasExperienceData(groupConfig) {
    return getVisibleCards(groupConfig && groupConfig.cards).some(
      cardHasExperienceData,
    );
  }

  function cardHasSpecModalData(cardConfig) {
    return !!(
      cardConfig &&
      (cardConfig.modal_detail_1_label ||
        cardConfig.modal_detail_1_value ||
        cardConfig.modal_detail_2_label ||
        cardConfig.modal_detail_2_value ||
        cardConfig.modal_detail_3_label ||
        cardConfig.modal_detail_3_value ||
        cardConfig.modal_detail_4_label ||
        cardConfig.modal_detail_4_value ||
        cardConfig.modal_detail_5_label ||
        cardConfig.modal_detail_5_value)
    );
  }

  function groupHasSpecModalData(groupConfig) {
    return getVisibleCards(groupConfig && groupConfig.cards).some(
      cardHasSpecModalData,
    );
  }

  function getModalType(groupConfig) {
    if (groupHasExperienceData(groupConfig)) {
      return "experience";
    }

    if (groupHasSpecModalData(groupConfig)) {
      return "specs";
    }

    return "";
  }

  function renderSwatchOption(option, optionIndex, groupIndex, cardConfig) {
    return [
      "<button",
      ' type="button"',
      ' class="product-page-section__color-option"',
      " data-bundle-option-button",
      ' data-bundle-group-index="',
      groupIndex,
      '"',
      ' data-bundle-option-index="',
      optionIndex,
      '"',
      ' data-bundle-value="',
      escapeHtml(option.value),
      '"',
      ' style="--product-option-swatch-color: ',
      escapeHtml(getSwatchColor(cardConfig)),
      ';"',
      option.disabled ? ' disabled aria-disabled="true"' : "",
      ">",
      '<span class="product-page-section__color-dot" aria-hidden="true"></span>',
      '<span class="product-page-section__color-label">',
      escapeHtml(getDisplayLabel(option.value, "swatch")),
      "</span>",
      "</button>",
    ].join("");
  }

  function renderCardOption(
    option,
    optionIndex,
    groupIndex,
    cardConfig,
    priceFormatter,
    renderedGroup,
    productOptionNames,
    hasParentBasePrice,
  ) {
    var title =
      cardConfig && cardConfig.title
        ? cardConfig.title
        : getDisplayLabel(option.value, "card");
    var subtitle = cardConfig && cardConfig.subtitle ? cardConfig.subtitle : "";
    var badge = cardConfig && cardConfig.badge ? cardConfig.badge : "";
    var imageUrl =
      cardConfig && cardConfig.image_url ? cardConfig.image_url : "";
    var priceMarkup = getOptionPriceMarkup(
      option,
      cardConfig,
      renderedGroup,
      priceFormatter,
      productOptionNames,
      hasParentBasePrice,
    );

    return [
      "<button",
      ' type="button"',
      ' class="product-page-section__card-option product-page-section__bundle-card"',
      " data-bundle-option-button",
      ' data-bundle-group-index="',
      groupIndex,
      '"',
      ' data-bundle-option-index="',
      optionIndex,
      '"',
      ' data-bundle-value="',
      escapeHtml(option.value),
      '"',
      option.disabled ? ' disabled aria-disabled="true"' : "",
      ">",
      imageUrl
        ? '<span class="product-page-section__card-option-media">' +
          '<img class="product-page-section__card-option-image" src="' +
          escapeHtml(imageUrl) +
          '" alt="' +
          escapeHtml(title) +
          '" loading="lazy">' +
          "</span>"
        : "",
      '<span class="product-page-section__bundle-card-copy">',
      '<span class="product-page-section__card-option-copy">',
      badge
        ? '<span class="product-page-section__card-option-badge">' +
          escapeHtml(badge) +
          "</span>"
        : "",
      '<span class="product-page-section__card-option-title">' +
        escapeHtml(title) +
        "</span>",
      subtitle
        ? '<span class="product-page-section__card-option-subtitle">' +
          escapeHtml(subtitle) +
          "</span>"
        : "",
      "</span>",
      renderCardDetails(cardConfig),
      "</span>",
      '<span class="product-page-section__bundle-card-side">',
      '<span class="product-page-section__bundle-card-price">' +
        escapeHtml(priceMarkup) +
        "</span>",
      "</span>",
      "</button>",
    ].join("");
  }

  function renderPillOption(option, optionIndex, groupIndex) {
    return [
      "<button",
      ' type="button"',
      ' class="product-page-section__value-option"',
      " data-bundle-option-button",
      ' data-bundle-group-index="',
      groupIndex,
      '"',
      ' data-bundle-option-index="',
      optionIndex,
      '"',
      ' data-bundle-value="',
      escapeHtml(option.value),
      '"',
      option.disabled ? ' disabled aria-disabled="true"' : "",
      ">",
      "<span>",
      escapeHtml(getDisplayLabel(option.value, "pill")),
      "</span>",
      "</button>",
    ].join("");
  }

  function renderAddOnSizeGuide(cardConfig, groupConfig, groupIndex, labels) {
    if (!hasAddOnSizeChart(cardConfig)) {
      return "";
    }

    var sizeChart = getAddOnSizeChart(cardConfig);
    var cardKey = getCardKey(cardConfig);
    var popoverId = "BundleSizeChart-" + groupIndex + "-" + cardKey;
    var sizeChartHeading = String(
      (sizeChart && sizeChart.heading) ||
        (labels && labels.sizeChartHeading) ||
        "",
    ).trim();
    var sizeChartContentMarkup = renderAddOnSizeChartTable(sizeChart, labels);
    var sizeChartContentHtml = String(
      (sizeChart && sizeChart.content_html) || "",
    ).trim();

    if (!sizeChartContentMarkup && !sizeChartContentHtml) {
      return "";
    }

    return [
      '<div class="product-page-section__hint product-page-section__size-chart" data-bundle-hint>',
      "<button",
      ' type="button"',
      ' class="product-page-section__hint-trigger product-page-section__size-chart-trigger product-page-section__bundle-addon-guide"',
      " data-bundle-hint-trigger",
      " data-bundle-addon-guide",
      ' aria-expanded="false"',
      ' aria-controls="',
      escapeHtml(popoverId),
      '"',
      ">",
      '<span class="product-page-section__hint-icon product-page-section__size-chart-icon product-page-section__bundle-addon-guide-icon" aria-hidden="true">',
      INFO_ICON,
      "</span>",
      "<span>",
      escapeHtml(
        (groupConfig && groupConfig.size_guide_label) || labels.sizeGuide,
      ),
      "</span>",
      "</button>",
      '<div id="',
      escapeHtml(popoverId),
      '" class="product-page-section__hint-popover product-page-section__size-chart-popover" data-bundle-hint-popover hidden>',
      '<div class="product-page-section__hint-inner product-page-section__size-chart-inner">',
      sizeChartHeading
        ? '<div class="product-page-section__hint-heading product-page-section__size-chart-heading">' +
          escapeHtml(sizeChartHeading) +
          "</div>"
        : "",
      sizeChartContentMarkup
        ? sizeChartContentMarkup
        : '<div class="product-page-section__hint-content product-page-section__size-chart-richtext">' +
          sizeChartContentHtml +
          "</div>",
      "</div></div></div>",
    ].join("");
  }

  function renderAddOnSizeChoices(cardConfig, groupIndex, cardKey, labels) {
    var sizeChoices = getAddOnSizeChoices(cardConfig);

    if (sizeChoices.length < 2) {
      return "";
    }

    return [
      '<div class="product-page-section__bundle-addon-sizes" role="group" aria-label="',
      escapeHtml(labels.size),
      '">',
      sizeChoices
        .map(function (choice) {
          return [
            "<button",
            ' type="button"',
            ' class="product-page-section__bundle-addon-size"',
            " data-bundle-addon-size-button",
            ' data-bundle-group-index="',
            groupIndex,
            '"',
            ' data-bundle-card-key="',
            escapeHtml(cardKey),
            '"',
            ' data-bundle-addon-size-value="',
            escapeHtml(choice.value),
            '"',
            ' data-bundle-addon-variant-id="',
            escapeHtml(choice.variantId),
            '"',
            ' data-bundle-addon-available="',
            choice.available ? "true" : "false",
            '"',
            choice.available ? "" : ' disabled aria-disabled="true"',
            ">",
            "<span>",
            escapeHtml(choice.value),
            "</span>",
            "</button>",
          ].join("");
        })
        .join(""),
      "</div>",
    ].join("");
  }

  function renderMultipleCardOption(
    cardConfig,
    groupConfig,
    groupIndex,
    priceFormatter,
    labels,
  ) {
    var cardKey = getCardKey(cardConfig);
    var defaultChoice = getDefaultAddOnChoice(cardConfig);
    var defaultSelection = {
      selected:
        normalizeBoolean(cardConfig && cardConfig.default_selected) &&
        !!defaultChoice,
      variantId: defaultChoice ? defaultChoice.variantId : "",
      sizeValue: defaultChoice ? defaultChoice.sizeValue : "",
    };
    var isAvailable = hasAvailableAddOnChoice(cardConfig);
    var title =
      (cardConfig && (cardConfig.title || cardConfig.option_value)) || "Add-on";
    var subtitle = cardConfig && cardConfig.subtitle ? cardConfig.subtitle : "";
    var badge = cardConfig && cardConfig.badge ? cardConfig.badge : "";
    var imageUrl = getAddOnCardImageUrl(cardConfig);
    var priceMarkup = getAddOnPriceMarkup(
      cardConfig,
      defaultSelection,
      priceFormatter,
    );

    return [
      '<article class="product-page-section__bundle-addon-card',
      defaultSelection.selected ? " is-selected" : "",
      isAvailable ? "" : " is-disabled",
      '" data-bundle-addon-card',
      ' data-bundle-group-index="',
      groupIndex,
      '"',
      ' data-bundle-card-key="',
      escapeHtml(cardKey),
      '"',
      ">",
      imageUrl
        ? '<div class="product-page-section__bundle-addon-media"><img class="product-page-section__bundle-addon-image" src="' +
          escapeHtml(imageUrl) +
          '" alt="' +
          escapeHtml(title) +
          '" loading="lazy"></div>'
        : "",
      '<div class="product-page-section__bundle-addon-copy">',
      '<div class="product-page-section__bundle-addon-title-wrap">',
      badge
        ? '<span class="product-page-section__bundle-addon-badge">' +
          escapeHtml(badge) +
          "</span>"
        : "",
      '<div class="product-page-section__bundle-addon-title">' +
        escapeHtml(title) +
        "</div>",
      subtitle
        ? '<div class="product-page-section__bundle-addon-subtitle">' +
          escapeHtml(subtitle) +
          "</div>"
        : "",
      "</div>",
      renderAddOnSizeGuide(cardConfig, groupConfig, groupIndex, labels),
      renderAddOnSizeChoices(cardConfig, groupIndex, cardKey, labels),
      "</div>",
      '<div class="product-page-section__bundle-addon-side">',
      "<button",
      ' type="button"',
      ' class="product-page-section__bundle-addon-toggle',
      defaultSelection.selected ? " is-selected" : "",
      '" data-bundle-addon-toggle',
      ' data-bundle-group-index="',
      groupIndex,
      '"',
      ' data-bundle-card-key="',
      escapeHtml(cardKey),
      '"',
      ' aria-pressed="',
      defaultSelection.selected ? "true" : "false",
      '"',
      isAvailable ? "" : ' disabled aria-disabled="true"',
      ">",
      '<span class="product-page-section__bundle-addon-toggle-icon" data-bundle-addon-toggle-icon>',
      defaultSelection.selected ? CHECK_ICON : "",
      "</span>",
      "</button>",
      '<div class="product-page-section__bundle-addon-price" data-bundle-addon-price>',
      escapeHtml(priceMarkup),
      "</div>",
      "</div>",
      "</article>",
    ].join("");
  }

  function renderMultipleGroupMarkup(
    entry,
    groupIndex,
    priceFormatter,
    sectionId,
    labels,
  ) {
    var groupConfig = entry.groupConfig || {};
    var cards = getVisibleCards(groupConfig.cards);

    if (!cards.length) {
      return "";
    }

    return [
      '<div class="product-page-section__option-group product-page-section__bundle-group product-page-section__bundle-group--multiple" data-bundle-group data-bundle-group-index="',
      groupIndex,
      '">',
      '<div class="product-page-section__option-header">',
      '<h2 class="product-page-section__option-title">',
      escapeHtml(groupConfig.heading || groupConfig.option_name || "Option"),
      "</h2>",
      renderLearnMore(groupConfig, groupIndex, sectionId, labels),
      "</div>",
      '<div class="product-page-section__bundle-addon-list">',
      cards
        .map(function (cardConfig) {
          return renderMultipleCardOption(
            cardConfig,
            groupConfig,
            groupIndex,
            priceFormatter,
            labels,
          );
        })
        .join(""),
      "</div>",
      renderGroupModal(groupConfig, groupIndex, sectionId, labels),
      "</div>",
    ].join("");
  }

  function renderModalDetails(cardConfig) {
    var rows = [];

    [
      ["modal_detail_1_label", "modal_detail_1_value"],
      ["modal_detail_2_label", "modal_detail_2_value"],
      ["modal_detail_3_label", "modal_detail_3_value"],
      ["modal_detail_4_label", "modal_detail_4_value"],
      ["modal_detail_5_label", "modal_detail_5_value"],
    ].forEach(function (pair) {
      if (!cardConfig || (!cardConfig[pair[0]] && !cardConfig[pair[1]])) {
        return;
      }

      rows.push(
        '<div class="product-page-section__bundle-modal-detail">' +
          '<div class="product-page-section__bundle-modal-detail-label">' +
          escapeHtml(cardConfig[pair[0]] || "") +
          "</div>" +
          '<div class="product-page-section__bundle-modal-detail-value">' +
          escapeHtml(cardConfig[pair[1]] || "") +
          "</div>" +
          "</div>",
      );
    });

    return rows.join("");
  }

  function renderRatingMarkup(value) {
    return [
      '<div class="product-page-section__experience-rating" data-bundle-rating="',
      escapeHtml(value || ""),
      '">',
      '<span class="product-page-section__experience-bar" data-bundle-rating-bar></span>',
      '<span class="product-page-section__experience-bar" data-bundle-rating-bar></span>',
      '<span class="product-page-section__experience-bar" data-bundle-rating-bar></span>',
      "</div>",
    ].join("");
  }

  function renderExperienceTooltipTrigger(tooltipKey, label, isEnabled) {
    if (!isEnabled) {
      return "";
    }

    return [
      '<button type="button" class="product-page-section__experience-tooltip-trigger" data-experience-tooltip-trigger data-experience-tooltip-key="',
      escapeHtml(tooltipKey || ""),
      '" aria-label="',
      escapeHtml(label || ""),
      '" aria-haspopup="true" aria-expanded="false">',
      '<span class="visually-hidden">',
      escapeHtml(label || ""),
      "</span>",
      '<span class="product-page-section__experience-label-icon" aria-hidden="true">',
      INFO_ICON,
      "</span>",
      "</button>",
    ].join("");
  }

  function renderExperienceModal(groupConfig, groupIndex, sectionId, labels) {
    var dialogId = "BundleOptionModal-" + sectionId + "-" + groupIndex;
    var cards = getVisibleCards(groupConfig.cards);
    var tooltipEnabled = (labels && labels.tooltipEnabled) || {};

    return [
      "<dialog",
      ' id="',
      dialogId,
      '"',
      ' class="product-page-section__experience-modal product-page-section__bundle-modal product-page-section__bundle-modal--specs"',
      " data-bundle-modal",
      ' data-bundle-modal-type="experience"',
      ' data-bundle-group-index="',
      groupIndex,
      '"',
      ' aria-label="',
      escapeHtml(
        groupConfig.modal_title || groupConfig.heading || labels.comparisonItem,
      ),
      '"',
      ">",
      '<div class="product-page-section__experience-modal-panel">',
      '<div class="product-page-section__experience-modal-header">',
      '<h3 class="product-page-section__experience-modal-title">',
      escapeHtml(
        groupConfig.modal_title || groupConfig.heading || labels.comparisonItem,
      ),
      "</h3>",
      '<button type="button" class="product-page-section__experience-modal-close" data-bundle-modal-close aria-label="Close dialog">&times;</button>',
      "</div>",
      '<p class="product-page-section__experience-modal-description" data-bundle-modal-description',
      groupConfig.modal_content ? "" : " hidden",
      ">",
      escapeHtml(groupConfig.modal_content || ""),
      "</p>",
      '<div class="product-page-section__experience-modal-table-wrap">',
      '<table class="product-page-section__experience-modal-table">',
      "<thead><tr>",
      "<th>",
      escapeHtml(labels.comparisonItem),
      "</th>",
      '<th><span class="product-page-section__experience-modal-heading"><span>',
      escapeHtml(labels.takeoff),
      "</span>",
      renderExperienceTooltipTrigger(
        "takeoff",
        labels.takeoff,
        tooltipEnabled.takeoff,
      ),
      "</span></th>",
      '<th><span class="product-page-section__experience-modal-heading"><span>',
      escapeHtml(labels.stability),
      "</span>",
      renderExperienceTooltipTrigger(
        "stability",
        labels.stability,
        tooltipEnabled.stability,
      ),
      "</span></th>",
      '<th><span class="product-page-section__experience-modal-heading"><span>',
      escapeHtml(labels.speed),
      "</span>",
      renderExperienceTooltipTrigger(
        "speed",
        labels.speed,
        tooltipEnabled.speed,
      ),
      "</span></th>",
      '<th><span class="product-page-section__experience-modal-heading"><span>',
      escapeHtml(labels.turning),
      "</span>",
      renderExperienceTooltipTrigger(
        "turning",
        labels.turning,
        tooltipEnabled.turning,
      ),
      "</span></th>",
      "<th>",
      escapeHtml(labels.bestFor),
      "</th>",
      "</tr></thead>",
      "<tbody>",
      cards
        .map(function (cardConfig) {
          var valueMatch = normalizeKey(cardConfig.option_value, {
            stripColorPrefix: true,
          });
          return [
            '<tr class="product-page-section__experience-modal-row" data-bundle-modal-option="',
            valueMatch,
            '">',
            '<td class="product-page-section__experience-modal-cell product-page-section__experience-modal-cell--wing">',
            '<div class="product-page-section__experience-modal-wing">',
            cardConfig.badge
              ? '<span class="product-page-section__experience-modal-badge">' +
                escapeHtml(cardConfig.badge) +
                "</span>"
              : "",
            '<div class="product-page-section__experience-modal-wing-copy">',
            '<div class="product-page-section__experience-modal-wing-title">',
            escapeHtml(cardConfig.modal_title || cardConfig.title || ""),
            "</div>",
            cardConfig.modal_subtitle
              ? '<div class="product-page-section__experience-modal-wing-subtitle">' +
                escapeHtml(cardConfig.modal_subtitle) +
                "</div>"
              : "",
            "</div></div></td>",
            '<td class="product-page-section__experience-modal-cell">',
            renderRatingMarkup(cardConfig.experience_takeoff),
            "</td>",
            '<td class="product-page-section__experience-modal-cell">',
            renderRatingMarkup(cardConfig.experience_stability),
            "</td>",
            '<td class="product-page-section__experience-modal-cell">',
            renderRatingMarkup(cardConfig.experience_speed),
            "</td>",
            '<td class="product-page-section__experience-modal-cell">',
            renderRatingMarkup(cardConfig.experience_turning),
            "</td>",
            '<td class="product-page-section__experience-modal-cell product-page-section__experience-modal-cell--best-for"><div class="product-page-section__experience-modal-best-for">',
            escapeHtml(cardConfig.experience_best_for || ""),
            "</div></td>",
            "</tr>",
          ].join("");
        })
        .join(""),
      "</tbody></table></div>",
      '<div id="',
      escapeHtml(dialogId + "-tooltip"),
      '" class="product-page-section__experience-tooltip-panel" data-experience-tooltip-panel role="tooltip" aria-hidden="true" hidden><div class="product-page-section__experience-tooltip-content" data-experience-tooltip-content></div></div>',
      "</div></dialog>",
    ].join("");
  }

  function renderSpecsModal(groupConfig, groupIndex, sectionId, labels) {
    var dialogId = "BundleOptionModal-" + sectionId + "-" + groupIndex;
    var cards = getVisibleCards(groupConfig.cards).filter(cardHasSpecModalData);
    var specificationsHeading =
      groupConfig.modal_specs_heading ||
      (labels && labels.specificationsHeading) ||
      "Specifications";
    var modalFooter = String((groupConfig && groupConfig.modal_footer) || "").trim();
    var normalizedModalFooter = modalFooter.replace(/^\*\s*/, "");
    var gridClasses =
      "product-page-section__bundle-modal-grid product-page-section__bundle-modal-grid--specs" +
      (cards.length === 1
        ? " product-page-section__bundle-modal-grid--specs-single"
        : "");

    if (!cards.length) {
      return "";
    }

    return [
      "<dialog",
      ' id="',
      dialogId,
      '"',
      ' class="product-page-section__experience-modal product-page-section__bundle-modal product-page-section__bundle-modal--specs"',
      " data-bundle-modal",
      ' data-bundle-modal-type="specs"',
      ' data-bundle-group-index="',
      groupIndex,
      '"',
      ' aria-label="',
      escapeHtml(
        groupConfig.modal_title || groupConfig.heading || "Option details",
      ),
      '"',
      ">",
      '<div class="product-page-section__experience-modal-panel product-page-section__bundle-modal-panel product-page-section__bundle-modal-panel--specs">',
      '<div class="product-page-section__experience-modal-header">',
      '<h3 class="product-page-section__experience-modal-title">',
      escapeHtml(
        groupConfig.modal_title || groupConfig.heading || "Option details",
      ),
      "</h3>",
      '<button type="button" class="product-page-section__experience-modal-close" data-bundle-modal-close aria-label="Close dialog">&times;</button>',
      "</div>",
      '<div class="product-page-section__bundle-modal-copy product-page-section__bundle-modal-copy--specs"',
      groupConfig.modal_content ? "" : " hidden",
      " data-bundle-modal-description>",
      escapeHtml(groupConfig.modal_content || "").replace(/\n/g, "<br>"),
      "</div>",
      '<div class="product-page-section__bundle-modal-section-title">',
      escapeHtml(specificationsHeading),
      "</div>",
      '<div class="',
      gridClasses,
      '">',
      cards
        .map(function (cardConfig) {
          var optionKey = normalizeKey(cardConfig.option_value, {
            stripColorPrefix: true,
          });
          return [
            '<article class="product-page-section__bundle-modal-card product-page-section__bundle-modal-card--specs" data-bundle-modal-option="',
            optionKey,
            '">',
            '<div class="product-page-section__bundle-modal-card-head">',
            cardConfig.image_url
              ? '<div class="product-page-section__bundle-modal-media"><img class="product-page-section__bundle-modal-image" src="' +
                escapeHtml(cardConfig.image_url) +
                '" alt="' +
                escapeHtml(cardConfig.modal_title || cardConfig.title || "") +
                '" loading="lazy"></div>'
              : "",
            '<div class="product-page-section__bundle-modal-card-title">',
            escapeHtml(cardConfig.modal_title || cardConfig.title || ""),
            "</div>",
            "</div>",
            '<div class="product-page-section__bundle-modal-details">',
            renderModalDetails(cardConfig),
            "</div>",
            "</article>",
          ].join("");
        })
        .join(""),
      "</div>",
      normalizedModalFooter
        ? '<div class="product-page-section__bundle-modal-footer">* ' +
          escapeHtml(normalizedModalFooter) +
          "</div>"
        : "",
      "</div>",
      "</dialog>",
    ].join("");
  }

  function renderLearnMore(groupConfig, groupIndex, sectionId, labels) {
    var modalType = getModalType(groupConfig);
    var dialogId = "BundleOptionModal-" + sectionId + "-" + groupIndex;

    if (modalType) {
      return [
        '<div class="product-page-section__option-learn-more">',
        "<button",
        ' type="button"',
        ' class="product-page-section__option-learn-more-trigger"',
        ' data-bundle-modal-open="',
        dialogId,
        '"',
        ' aria-haspopup="dialog"',
        ' aria-controls="',
        dialogId,
        '"',
        ">",
        '<span class="product-page-section__option-learn-more-icon" aria-hidden="true">',
        INFO_ICON,
        "</span>",
        "<span>",
        escapeHtml(labels.learnMore),
        "</span>",
        "</button>",
        "</div>",
      ].join("");
    }

    if (!groupConfig || !groupConfig.learn_more_content) {
      return "";
    }

    var popoverId = "BundleOptionHint-" + sectionId + "-" + groupIndex;

    return [
      '<div class="product-page-section__hint product-page-section__option-learn-more" data-bundle-hint>',
      "<button",
      ' type="button"',
      ' class="product-page-section__hint-trigger product-page-section__option-learn-more-trigger"',
      " data-bundle-hint-trigger",
      ' aria-expanded="false"',
      ' aria-controls="',
      popoverId,
      '"',
      ">",
      '<span class="product-page-section__hint-icon product-page-section__option-learn-more-icon" aria-hidden="true">',
      INFO_ICON,
      "</span>",
      "<span>",
      escapeHtml(labels.learnMore),
      "</span>",
      "</button>",
      '<div id="',
      popoverId,
      '" class="product-page-section__hint-popover product-page-section__option-learn-more-popover" data-bundle-hint-popover hidden>',
      '<div class="product-page-section__hint-inner product-page-section__option-learn-more-inner">',
      groupConfig.learn_more_heading
        ? '<div class="product-page-section__hint-heading product-page-section__option-learn-more-heading">' +
          escapeHtml(groupConfig.learn_more_heading) +
          "</div>"
        : "",
      '<div class="product-page-section__hint-content product-page-section__option-learn-more-content">' +
        escapeHtml(groupConfig.learn_more_content).replace(/\n/g, "<br>") +
        "</div>",
      "</div></div></div>",
    ].join("");
  }

  function renderGroupModal(groupConfig, groupIndex, sectionId, labels) {
    var modalType = getModalType(groupConfig);

    if (modalType === "experience") {
      return renderExperienceModal(groupConfig, groupIndex, sectionId, labels);
    }

    if (modalType === "specs") {
      return renderSpecsModal(groupConfig, groupIndex, sectionId, labels);
    }

    return "";
  }

  function renderBundleGroupMarkup(
    entry,
    groupIndex,
    priceFormatter,
    sectionId,
    labels,
    productOptionNames,
    hasParentBasePrice,
  ) {
    if (entry.mode === "hidden-source" || (entry && entry.hiddenInUi)) {
      return "";
    }

    if (entry.mode === "multiple") {
      return renderMultipleGroupMarkup(
        entry,
        groupIndex,
        priceFormatter,
        sectionId,
        labels,
      );
    }

    var group = entry.group;
    var groupConfig = entry.groupConfig;
    var renderType = inferRenderType(groupConfig);
    var selectedValue = group && group.select ? group.select.value : "";
    var selectedCardKey = normalizeKey(selectedValue, {
      stripColorPrefix: true,
    });
    var optionsMarkup = group.options
      .filter(function (option) {
        if (!option.value || /please select/i.test(option.text || "")) {
          return false;
        }

        if (isSourceOptionMarketHidden(option, groupConfig)) {
          return false;
        }

        var optionCardConfig = findMatchingCard(
          groupConfig ? groupConfig.cards : [],
          option.value,
        );

        if (!isCardHiddenFromUi(optionCardConfig)) {
          return true;
        }

        return (
          normalizeKey(option.value, { stripColorPrefix: true }) ===
          selectedCardKey
        );
      })
      .map(function (option, optionIndex) {
        var cardConfig = findMatchingCard(
          groupConfig ? groupConfig.cards : [],
          option.value,
        );

        if (renderType === "swatch") {
          return renderSwatchOption(
            option,
            optionIndex,
            groupIndex,
            cardConfig,
          );
        }

        if (renderType === "card") {
          return renderCardOption(
            option,
            optionIndex,
            groupIndex,
            cardConfig,
            priceFormatter,
            entry,
            productOptionNames,
            hasParentBasePrice,
          );
        }

        return renderPillOption(option, optionIndex, groupIndex);
      })
      .join("");

    return [
      '<div class="product-page-section__option-group product-page-section__bundle-group" data-bundle-group data-bundle-group-index="',
      groupIndex,
      '">',
      '<div class="product-page-section__option-header">',
      '<h2 class="product-page-section__option-title">',
      escapeHtml(
        (groupConfig && groupConfig.heading) ||
          group.label ||
          group.propertyName ||
          "Option",
      ),
      "</h2>",
      renderLearnMore(groupConfig, groupIndex, sectionId, labels),
      "</div>",
      '<div class="product-page-section__option-values',
      renderType === "swatch"
        ? " product-page-section__option-values--color"
        : "",
      renderType === "card"
        ? " product-page-section__option-values--cards"
        : "",
      '">',
      optionsMarkup,
      "</div>",
      renderGroupModal(groupConfig, groupIndex, sectionId, labels),
      "</div>",
    ].join("");
  }

  function initBundleBoardSection(section) {
    var root = section.querySelector("[data-bundle-options-root]");
    if (!section || !root) {
      return;
    }

    if (typeof section.aerofoilsBundleBoardCleanup === "function") {
      section.aerofoilsBundleBoardCleanup();
    }

    var includedBlock = section.querySelector("[data-bundle-included-block]");
    var includedGridShell = includedBlock
      ? includedBlock.querySelector("[data-bundle-included-grid-shell]")
      : null;
    var includedGrid = includedBlock
      ? includedBlock.querySelector("[data-bundle-included-grid]")
      : null;
    var includedToggleWrap = includedBlock
      ? includedBlock.querySelector("[data-bundle-included-toggle-wrap]")
      : null;
    var includedToggleButton = includedBlock
      ? includedBlock.querySelector("[data-bundle-included-toggle]")
      : null;
    var includedToggleLabel = includedBlock
      ? includedBlock.querySelector("[data-bundle-included-toggle-label]")
      : null;
    var specificationsApi = window.AerofoilsProductSpecifications || null;
    var specificationGroups = specificationsApi
      ? specificationsApi.collectGroups(section)
      : [];
    var form = section.querySelector(".product-page-section__form");
    var variantInput = form
      ? form.querySelector('[data-product-variant-id], [name="id"]')
      : null;
    var variantId = section.getAttribute("data-bundle-variant-id") || "";
    var productVariantsScript = section.querySelector("[data-product-variants]");
    var productOptionNamesScript = section.querySelector(
      "[data-product-option-names]",
    );
    var labels = getBundleLabels(section);
    var priceNodes = Array.prototype.slice.call(
      section.querySelectorAll("[data-product-price]"),
    );
    var comparePriceNodes = Array.prototype.slice.call(
      section.querySelectorAll("[data-product-compare-price]"),
    );
    var submitButtons = Array.prototype.slice.call(
      section.querySelectorAll("[data-product-submit]"),
    );
    var priceFormatter = createPriceFormatter(
      priceNodes[0] ? priceNodes[0].textContent : "",
    );
    var groupConfigs = parseGroupConfig(section);
    var presetParamMap = parseBundlePresetParams();
    var configMap = buildGroupConfigMap(groupConfigs);
    var configuratorStatus = String(
      section.getAttribute("data-configurator-status") || "",
    )
      .trim()
      .toLowerCase();
    var configuratorRuntime = parseConfiguratorRuntime(section);
    var configuratorCountry = parseConfiguratorCountry(section);
    var productVariants = [];
    var productOptionNames = [];
    var hasParentBasePrice = false;
    var runtimeRefreshPromise = null;
    var state = {
      renderedGroups: [],
      sourceRoot: null,
      multipleSelections: {},
      hasMultipleGroups: false,
      includedExpanded: false,
      includedCollapseFrame: 0,
      sourceHydrationObserver: null,
      sourceHydrationTimer: 0,
      sourceHydrationAttempts: 0,
      sourceHydrationSignature: "",
      hasUserInteractedWithBundle: false,
      deferredInteractiveReady: false,
      deferredInteractiveScheduled: false,
      deferredBelowFoldReady: false,
      deferredBelowFoldObserved: false,
      deferredBelowFoldCleanupFns: [],
      isPublishedConfigurator:
        configuratorStatus === "published" && !!configuratorRuntime,
    };
    var includedGridObserver = null;
    var includedResizeHandler = null;

    function runWhenIdle(callback, timeout) {
      if (typeof callback !== "function") {
        return;
      }

      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(callback, {
          timeout: typeof timeout === "number" ? timeout : 1200,
        });
        return;
      }

      window.setTimeout(callback, 180);
    }

    function setBundleRootLoading() {
      root.hidden = false;
      root.classList.add("product-page-section__bundle-root--loading");
      root.setAttribute("aria-busy", "true");
    }

    function setBundleRootReady() {
      root.hidden = false;
      root.classList.remove("product-page-section__bundle-root--loading");
      root.setAttribute("aria-busy", "false");
    }

    setBundleRootLoading();

    if (includedToggleButton) {
      includedToggleButton.addEventListener("mousedown", function (event) {
        event.preventDefault();
      });

      includedToggleButton.addEventListener("click", function () {
        toggleIncludedCollapse();
      });
    }

    if (productVariantsScript) {
      try {
        productVariants = JSON.parse(productVariantsScript.textContent || "[]");
      } catch (error) {
        productVariants = [];
      }
    }

    if (productOptionNamesScript) {
      try {
        productOptionNames = JSON.parse(
          productOptionNamesScript.textContent || "[]",
        );
      } catch (error) {
        productOptionNames = [];
      }
    }

    hasParentBasePrice = productVariants.some(function (variant) {
      return Number((variant && variant.price) || 0) > 0;
    });

    function getRuntimeGroupsByKey() {
      if (!state.isPublishedConfigurator || !configuratorRuntime) {
        return {};
      }

      return (configuratorRuntime.groups || []).reduce(function (result, group) {
        var groupKey = normalizeKey(group && group.k, {
          stripColorPrefix: false,
          stripSelectPrefix: false,
        });

        if (groupKey) {
          result[groupKey] = group;
        }

        return result;
      }, {});
    }

    function updateRuntimeScriptMarkup() {
      var runtimeScript = section.querySelector("[data-configurator-runtime]");

      if (!runtimeScript) {
        return;
      }

      runtimeScript.textContent = JSON.stringify(configuratorRuntime || null);
    }

    function buildSectionRefreshUrl() {
      if (typeof window === "undefined" || !window.location) {
        return "";
      }

      var sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set("section_id", section.id);
      return sectionUrl.toString();
    }

    function applyPublishedRuntimeRefresh(nextSection) {
      var nextStatus = String(
        nextSection && nextSection.getAttribute("data-configurator-status"),
      )
        .trim()
        .toLowerCase();
      var nextRuntime = parseConfiguratorRuntime(nextSection);
      var nextCountry = parseConfiguratorCountry(nextSection) || configuratorCountry;

      if (nextStatus !== "published" || !nextRuntime) {
        return false;
      }

      var prevRuntimeText = JSON.stringify(configuratorRuntime || null);
      var nextRuntimeText = JSON.stringify(nextRuntime);
      var hasChanged =
        prevRuntimeText !== nextRuntimeText || nextCountry !== configuratorCountry;

      configuratorRuntime = nextRuntime;
      configuratorCountry = nextCountry;
      state.isPublishedConfigurator = true;
      section.setAttribute("data-configurator-status", "published");
      section.setAttribute("data-country", configuratorCountry);

      if (typeof nextRuntime.rev === "number") {
        section.setAttribute("data-configurator-rev", String(nextRuntime.rev));
      }

      updateRuntimeScriptMarkup();
      return hasChanged;
    }

    async function refreshPublishedRuntimeFromStorefront(options) {
      var settings = options || {};

      if (!state.isPublishedConfigurator) {
        return false;
      }

      if (runtimeRefreshPromise && settings.force !== true) {
        return runtimeRefreshPromise;
      }

      runtimeRefreshPromise = (async function () {
        var refreshUrl = buildSectionRefreshUrl();

        if (!refreshUrl || typeof fetch !== "function") {
          return false;
        }

        var response = await fetch(refreshUrl, {
          headers: {
            Accept: "text/html",
          },
          credentials: "same-origin",
        });

        if (!response.ok) {
          throw new Error("Configurator runtime refresh failed");
        }

        var html = await response.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var nextSection = doc.querySelector("[data-bundle-board]");
        var hasChanged = applyPublishedRuntimeRefresh(nextSection);

        if (hasChanged && settings.syncUi !== false) {
          syncFromSource();
        }

        return hasChanged;
      })();

      try {
        return await runtimeRefreshPromise;
      } finally {
        runtimeRefreshPromise = null;
      }
    }

    function getRuntimeGroupKey(groupConfig) {
      return normalizeKey(groupConfig && groupConfig.key, {
        stripColorPrefix: false,
        stripSelectPrefix: false,
      });
    }

    function getRuntimeGroupForConfig(groupConfig) {
      var runtimeGroupsByKey = getRuntimeGroupsByKey();
      var runtimeKey = getRuntimeGroupKey(groupConfig);
      var fallbackKeys = [
        normalizeKey(groupConfig && groupConfig.option_name),
        normalizeKey(groupConfig && groupConfig.heading),
      ];

      if (runtimeKey && runtimeGroupsByKey[runtimeKey]) {
        return runtimeGroupsByKey[runtimeKey];
      }

      for (var fallbackIndex = 0; fallbackIndex < fallbackKeys.length; fallbackIndex += 1) {
        var fallbackKey = fallbackKeys[fallbackIndex];

        if (fallbackKey && runtimeGroupsByKey[fallbackKey]) {
          return runtimeGroupsByKey[fallbackKey];
        }
      }

      return null;
    }

    function getRuntimeCardForConfig(groupConfig, cardConfig) {
      var runtimeGroup = getRuntimeGroupForConfig(groupConfig);
      var cardKey = getCardKey(cardConfig);

      if (!runtimeGroup || !cardKey) {
        return null;
      }

      return (
        (runtimeGroup.cards || []).find(function (runtimeCard) {
          return (
            normalizeKey(runtimeCard && runtimeCard.k, {
              stripColorPrefix: false,
              stripSelectPrefix: false,
            }) === cardKey
          );
        }) || null
      );
    }

    function resolveRuntimeUnitPrice(variantId, countryCode) {
      var normalizedCountry = String(countryCode || "")
        .trim()
        .toUpperCase();
      var index = Array.isArray(configuratorRuntime && configuratorRuntime.pi)
        ? configuratorRuntime.pi.indexOf(Number(variantId || 0))
        : -1;

      if (index >= 0) {
        var countryPrice = normalizedCountry
          ? configuratorRuntime.pc &&
            configuratorRuntime.pc[normalizedCountry] &&
            configuratorRuntime.pc[normalizedCountry][index]
          : null;

        if (countryPrice != null && Number.isFinite(Number(countryPrice))) {
          return Number(countryPrice);
        }

        var defaultPrice = configuratorRuntime.pd
          ? configuratorRuntime.pd[index]
          : null;

        if (defaultPrice != null && Number.isFinite(Number(defaultPrice))) {
          return Number(defaultPrice);
        }
      }

      var legacyPrice =
        configuratorRuntime && configuratorRuntime.p
          ? configuratorRuntime.p[String(variantId)]
          : null;

      return legacyPrice != null && Number.isFinite(Number(legacyPrice))
        ? Number(legacyPrice)
        : null;
    }

    function resolveRuntimeExpansion(payload) {
      if (
        !state.isPublishedConfigurator ||
        !configuratorRuntime ||
        !payload ||
        payload.v !== configuratorRuntime.v ||
        payload.rev !== configuratorRuntime.rev
      ) {
        return null;
      }

      var groupsByKey = getRuntimeGroupsByKey();
      var quantities = {};
      var seenGroups = {};

      function addRuntimeComponent(id, quantity) {
        var numericId = Number(id || 0);
        var numericQuantity = Number(quantity || 0);

        if (
          !Number.isInteger(numericId) ||
          numericId <= 0 ||
          !Number.isInteger(numericQuantity) ||
          numericQuantity <= 0
        ) {
          return false;
        }

        quantities[numericId] = (quantities[numericId] || 0) + numericQuantity;
        return true;
      }

      for (var entryIndex = 0; entryIndex < payload.s.length; entryIndex += 1) {
        var entry = payload.s[entryIndex];

        if (!Array.isArray(entry) || entry.length < 2) {
          return null;
        }

        var groupKey = entry[0];
        var cardKey = entry[1];
        var chosenVariantId = entry.length > 2 ? entry[2] : null;

        if (typeof groupKey !== "string" || typeof cardKey !== "string") {
          return null;
        }

        var runtimeGroup = groupsByKey[normalizeKey(groupKey, {
          stripColorPrefix: false,
          stripSelectPrefix: false,
        })];

        if (!runtimeGroup || runtimeGroup.hidden) {
          return null;
        }

        var normalizedGroupKey = normalizeKey(groupKey, {
          stripColorPrefix: false,
          stripSelectPrefix: false,
        });

        if (seenGroups[normalizedGroupKey]) {
          return null;
        }

        seenGroups[normalizedGroupKey] = true;

        var runtimeCard =
          (runtimeGroup.cards || []).find(function (candidate) {
            return (
              normalizeKey(candidate && candidate.k, {
                stripColorPrefix: false,
                stripSelectPrefix: false,
              }) ===
              normalizeKey(cardKey, {
                stripColorPrefix: false,
                stripSelectPrefix: false,
              })
            );
          }) || null;

        if (!runtimeCard) {
          return null;
        }

        for (
          var componentIndex = 0;
          componentIndex < (runtimeCard.c || []).length;
          componentIndex += 1
        ) {
          var runtimeComponent = runtimeCard.c[componentIndex];

          if (
            !addRuntimeComponent(
              runtimeComponent && runtimeComponent.id,
              runtimeComponent && runtimeComponent.q,
            )
          ) {
            return null;
          }
        }

        var hasChoices =
          Array.isArray(runtimeCard.vc) && runtimeCard.vc.length > 0;

        if (chosenVariantId != null) {
          var numericChosenVariantId = Number(chosenVariantId);

          if (
            !hasChoices ||
            runtimeCard.vc.indexOf(numericChosenVariantId) === -1 ||
            !addRuntimeComponent(numericChosenVariantId, 1)
          ) {
            return null;
          }
        } else if (hasChoices && (runtimeCard.c || []).length === 0) {
          return null;
        }
      }

      for (
        var runtimeGroupIndex = 0;
        runtimeGroupIndex < configuratorRuntime.groups.length;
        runtimeGroupIndex += 1
      ) {
        var group = configuratorRuntime.groups[runtimeGroupIndex];
        var normalizedRuntimeGroupKey = normalizeKey(group && group.k, {
          stripColorPrefix: false,
          stripSelectPrefix: false,
        });

        if (group && group.hidden) {
          var hiddenCard = group.cards && group.cards[0];

          if (!hiddenCard) {
            return null;
          }

          for (
            var hiddenIndex = 0;
            hiddenIndex < (hiddenCard.c || []).length;
            hiddenIndex += 1
          ) {
            var hiddenComponent = hiddenCard.c[hiddenIndex];

            if (
              !addRuntimeComponent(
                hiddenComponent && hiddenComponent.id,
                hiddenComponent && hiddenComponent.q,
              )
            ) {
              return null;
            }
          }
        } else if (
          group &&
          group.req &&
          normalizedRuntimeGroupKey &&
          !seenGroups[normalizedRuntimeGroupKey]
        ) {
          return null;
        }
      }

      var componentIds = Object.keys(quantities);

      if (!componentIds.length) {
        return null;
      }

      return componentIds.map(function (componentId) {
        return {
          id: Number(componentId),
          q: quantities[componentId],
        };
      });
    }

    function getRuntimeComponentsTotal(components, countryCode) {
      return (components || []).reduce(function (sum, component) {
        var unitPrice = resolveRuntimeUnitPrice(
          component && component.id,
          countryCode,
        );

        return sum + Number(unitPrice || 0) * Number((component && component.q) || 0);
      }, 0);
    }

    function getCardComponents(cardConfig) {
      return Array.isArray(cardConfig && cardConfig.components)
        ? cardConfig.components
        : [];
    }

    function getCardVariantChoices(cardConfig) {
      return Array.isArray(cardConfig && cardConfig.variant_choices)
        ? cardConfig.variant_choices
        : [];
    }

    function getPublishedCardChosenVariant(groupConfig, cardConfig) {
      var runtimeCard = getRuntimeCardForConfig(groupConfig, cardConfig);
      var runtimeChoiceIds = Array.isArray(runtimeCard && runtimeCard.vc)
        ? runtimeCard.vc.map(function (variantId) {
            return String(variantId);
          })
        : [];
      var availableChoices = getCardVariantChoices(cardConfig).filter(function (
        choice,
      ) {
        var choiceId = String((choice && choice.id) || "");

        if (!choiceId || !(choice && choice.available)) {
          return false;
        }

        if (!runtimeChoiceIds.length) {
          return true;
        }

        return runtimeChoiceIds.indexOf(choiceId) !== -1;
      });

      return availableChoices.length === 1 ? availableChoices[0] : null;
    }

    function getPublishedCardChosenVariantId(groupConfig, cardConfig) {
      var chosenVariant = getPublishedCardChosenVariant(groupConfig, cardConfig);
      var chosenVariantId = Number(chosenVariant && chosenVariant.id);

      return Number.isFinite(chosenVariantId) && chosenVariantId > 0
        ? chosenVariantId
        : null;
    }

    function getPublishedCardRuntimeComponents(groupConfig, cardConfig) {
      var runtimeCard = getRuntimeCardForConfig(groupConfig, cardConfig);
      var chosenVariantId = getPublishedCardChosenVariantId(
        groupConfig,
        cardConfig,
      );
      var components = Array.isArray(runtimeCard && runtimeCard.c)
        ? runtimeCard.c.map(function (component) {
            return {
              id: Number(component && component.id),
              q: Number(component && component.q),
            };
          })
        : [];

      if (chosenVariantId != null) {
        components.push({
          id: chosenVariantId,
          q: 1,
        });
      }

      return components.filter(function (component) {
        return (
          Number.isFinite(component && component.id) &&
          component.id > 0 &&
          Number.isFinite(component && component.q) &&
          component.q > 0
        );
      });
    }

    function getPublishedDefaultCard(groupConfig) {
      var visibleCards = getPublishedVisibleCards(groupConfig);

      return (
        visibleCards.find(function (card) {
          return normalizeBoolean(card && card.default_selected);
        }) ||
        visibleCards[0] ||
        null
      );
    }

    function getPublishedGroupPriceValue(groupConfig, cardConfig) {
      var defaultCard = getPublishedDefaultCard(groupConfig);
      var absoluteComponents = getPublishedCardRuntimeComponents(
        groupConfig,
        cardConfig,
      );
      var defaultComponents = getPublishedCardRuntimeComponents(
        groupConfig,
        defaultCard,
      );

      if (!absoluteComponents.length) {
        return null;
      }

      var absoluteValue = getRuntimeComponentsTotal(
        absoluteComponents,
        configuratorCountry,
      );

      if (!defaultComponents.length) {
        return absoluteValue;
      }

      return (
        absoluteValue -
        getRuntimeComponentsTotal(defaultComponents, configuratorCountry)
      );
    }

    function getPublishedPriceMarkup(groupConfig, cardConfig) {
      var value = getPublishedGroupPriceValue(groupConfig, cardConfig);

      if (value == null || isNaN(value) || value === 0) {
        return "";
      }

      return (value > 0 ? "+" : "-") + priceFormatter(Math.abs(value));
    }

    function getSelectedCardForEntry(entry) {
      var selectedValue =
        entry && entry.group && entry.group.select ? entry.group.select.value : "";

      return findMatchingCard(
        entry && entry.groupConfig ? entry.groupConfig.cards : [],
        selectedValue,
      );
    }

    function buildPublishedSelectionPayload() {
      if (!state.isPublishedConfigurator || !configuratorRuntime) {
        return null;
      }

      return {
        v: configuratorRuntime.v,
        rev: configuratorRuntime.rev,
        s: state.renderedGroups.reduce(function (result, entry) {
          if (!entry || entry.mode !== "source" || !entry.groupConfig) {
            return result;
          }

          var runtimeGroup = getRuntimeGroupForConfig(entry.groupConfig);

          if (!runtimeGroup || runtimeGroup.hidden || runtimeGroup.t !== "single") {
            return result;
          }

          var selectedCard = getSelectedCardForEntry(entry);
          var runtimeCard = getRuntimeCardForConfig(
            entry.groupConfig,
            selectedCard,
          );
          var chosenVariantId = getPublishedCardChosenVariantId(
            entry.groupConfig,
            selectedCard,
          );

          if (!selectedCard || !runtimeCard) {
            return result;
          }

          result.push([
            runtimeGroup.k,
            String(runtimeCard.k || ""),
            chosenVariantId,
          ]);

          return result;
        }, []),
      };
    }

    function buildPublishedDisplaySummary() {
      return state.renderedGroups.reduce(function (result, entry) {
        if (!entry || entry.mode !== "source" || !entry.groupConfig) {
          return result;
        }

        var selectedCard = getSelectedCardForEntry(entry);

        if (!selectedCard) {
          return result;
        }

        var groupLabel =
          entry.groupConfig.heading || entry.groupConfig.option_name || "Option";
        var cardLabel =
          selectedCard.title || selectedCard.option_value || selectedCard.key || "";

        if (groupLabel && cardLabel) {
          result.push(groupLabel + ": " + cardLabel);
        }

        return result;
      }, []).join(" | ");
    }

    function ensureHiddenPropertyInput(propertyKey, propertyValue) {
      if (!state.sourceRoot) {
        return;
      }

      var inputSelector =
        'input[name="properties[' + propertyKey.replace(/"/g, '\\"') + ']"]';
      var hiddenInput = state.sourceRoot.querySelector(inputSelector);

      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = "properties[" + propertyKey + "]";
        state.sourceRoot.appendChild(hiddenInput);
      }

      hiddenInput.value = propertyValue || "";
    }

    function getPublishedSingleCardAvailable(groupConfig, cardConfig) {
      var runtimeCard = getRuntimeCardForConfig(groupConfig, cardConfig);
      var components = getCardComponents(cardConfig);
      var variantChoices = getCardVariantChoices(cardConfig);
      var product = cardConfig && cardConfig.product;
      var productVariants = product && Array.isArray(product.variants)
        ? product.variants
        : [];

      if (
        components.length &&
        components.some(function (component) {
          return component && component.available === false;
        })
      ) {
        return false;
      }

      if (runtimeCard && Array.isArray(runtimeCard.vc) && runtimeCard.vc.length) {
        var runtimeChoiceIds = runtimeCard.vc.map(function (variantId) {
          return String(variantId);
        });
        var availableRuntimeChoices = variantChoices.filter(function (variant) {
          return (
            runtimeChoiceIds.indexOf(String((variant && variant.id) || "")) !== -1
          );
        });

        if (availableRuntimeChoices.length) {
          return availableRuntimeChoices.some(function (variant) {
            return !!(variant && variant.available);
          });
        }

        return false;
      }

      if (variantChoices.length) {
        return variantChoices.some(function (variant) {
          return !!(variant && variant.available);
        });
      }

      if (components.length) {
        return true;
      }

      if (productVariants.length) {
        return productVariants.some(function (variant) {
          return !!(variant && variant.available);
        });
      }

      return true;
    }

    function getPublishedMatchedCards(groupConfig) {
      var runtimeGroup = getRuntimeGroupForConfig(groupConfig);
      var runtimeCardKeys = (runtimeGroup && runtimeGroup.cards || []).map(function (card) {
        return normalizeKey(card && card.k, {
          stripColorPrefix: false,
          stripSelectPrefix: false,
        });
      });

      return (groupConfig && groupConfig.cards || []).filter(function (card) {
        return runtimeCardKeys.indexOf(getCardKey(card)) !== -1;
      });
    }

    function getPublishedVisibleCards(groupConfig) {
      return getVisibleCards(getPublishedMatchedCards(groupConfig));
    }

    function shouldHideSourceGroupUi(groupConfig, sourceGroup) {
      if (isGroupHiddenFromUi(groupConfig)) {
        return true;
      }

      return (
        getMeaningfulSourceOptions(sourceGroup).length > 0 &&
        getRenderableSourceOptions(sourceGroup, groupConfig).length === 0
      );
    }

    function buildPublishedSourceRoot() {
      if (!state.isPublishedConfigurator || !configuratorRuntime) {
        return null;
      }

      var publishedRoot = document.createElement("div");

      publishedRoot.setAttribute("data-bundle-runtime-root", "true");

      groupConfigs.forEach(function (groupConfig, groupIndex) {
        if (!groupConfig || inferSelectionType(groupConfig) === "multiple") {
          return;
        }

        var runtimeGroup = getRuntimeGroupForConfig(groupConfig);

        if (!runtimeGroup || runtimeGroup.hidden || runtimeGroup.t !== "single") {
          return;
        }

        var matchedCards = getPublishedMatchedCards(groupConfig);
        var visibleCards = getPublishedVisibleCards(groupConfig);
        var defaultCard =
          visibleCards.find(function (cardConfig) {
            return normalizeBoolean(cardConfig && cardConfig.default_selected);
          }) ||
          visibleCards[0] ||
          matchedCards.find(function (cardConfig) {
            return normalizeBoolean(cardConfig && cardConfig.default_selected);
          }) ||
          matchedCards[0] ||
          null;

        if (!matchedCards.length) {
          return;
        }

        var fieldId = "BundleRuntimeGroup-" + section.id + "-" + groupIndex;
        var labelNode = document.createElement("label");
        var selectNode = document.createElement("select");

        labelNode.setAttribute("for", fieldId);
        labelNode.textContent =
          groupConfig.heading || groupConfig.option_name || runtimeGroup.k || "Option";
        selectNode.id = fieldId;
        selectNode.name =
          "properties[" +
          (groupConfig.option_name ||
            groupConfig.heading ||
            runtimeGroup.k ||
            "Option") +
          "]";

        matchedCards.forEach(function (cardConfig) {
          var optionNode = document.createElement("option");
          var optionValue =
            cardConfig.option_value || cardConfig.title || cardConfig.key || "";

          optionNode.value = optionValue;
          optionNode.text = optionValue;
          optionNode.selected =
            !!defaultCard && getCardKey(cardConfig) === getCardKey(defaultCard);
          optionNode.disabled = !getPublishedSingleCardAvailable(
            groupConfig,
            cardConfig,
          );
          selectNode.appendChild(optionNode);
        });

        publishedRoot.appendChild(labelNode);
        publishedRoot.appendChild(selectNode);
      });

      return publishedRoot;
    }

    function normalizeRatingLevel(value) {
      var normalizedValue = String(value || "")
        .trim()
        .toLowerCase();
      var numericValue = parseInt(normalizedValue, 10);

      if (!isNaN(numericValue)) {
        return Math.max(0, Math.min(3, numericValue));
      }

      if (
        normalizedValue === "high" ||
        normalizedValue === "max" ||
        normalizedValue === "maximum" ||
        normalizedValue === "advanced"
      ) {
        return 3;
      }

      if (
        normalizedValue === "medium" ||
        normalizedValue === "mid" ||
        normalizedValue === "balanced" ||
        normalizedValue === "allrounder"
      ) {
        return 2;
      }

      if (
        normalizedValue === "low" ||
        normalizedValue === "min" ||
        normalizedValue === "minimum" ||
        normalizedValue === "beginner"
      ) {
        return 1;
      }

      return 0;
    }

    function syncRatingBars(scope) {
      Array.prototype.slice
        .call((scope || root).querySelectorAll("[data-bundle-rating]"))
        .forEach(function (ratingElement) {
          var level = normalizeRatingLevel(
            ratingElement.getAttribute("data-bundle-rating"),
          );
          Array.prototype.slice
            .call(ratingElement.querySelectorAll("[data-bundle-rating-bar]"))
            .forEach(function (bar, index) {
              bar.classList.toggle("is-active", index < level);
            });
        });
    }

    function setHintOpen(hintRoot, nextOpen) {
      var trigger =
        hintRoot && hintRoot.querySelector("[data-bundle-hint-trigger]");
      var popover =
        hintRoot && hintRoot.querySelector("[data-bundle-hint-popover]");
      var addOnCard = hintRoot && hintRoot.closest("[data-bundle-addon-card]");

      if (!hintRoot || !trigger || !popover) {
        return;
      }

      hintRoot.classList.toggle("is-open", nextOpen);

      if (addOnCard) {
        addOnCard.classList.toggle("is-popover-open", nextOpen);
      }

      trigger.setAttribute("aria-expanded", nextOpen ? "true" : "false");
      popover.hidden = !nextOpen;
    }

    function closeHints(exceptRoot) {
      Array.prototype.slice
        .call(root.querySelectorAll("[data-bundle-hint]"))
        .forEach(function (hintRoot) {
          if (exceptRoot && exceptRoot === hintRoot) {
            return;
          }

          setHintOpen(hintRoot, false);
        });
    }

    function openDialog(dialog) {
      if (!dialog) {
        return;
      }

      if (typeof dialog.showModal === "function") {
        dialog.showModal();
        return;
      }

      dialog.setAttribute("open", "open");
    }

    function closeDialog(dialog) {
      if (!dialog || !dialog.hasAttribute("open")) {
        return;
      }

      if (typeof dialog.close === "function") {
        dialog.close();
        return;
      }

      dialog.removeAttribute("open");
    }

    function closeAllModals() {
      Array.prototype.slice
        .call(root.querySelectorAll("[data-bundle-modal]"))
        .forEach(closeDialog);
    }

    function isColorOptionName(optionName) {
      var normalizedOptionName = normalizeKey(optionName || "");

      return (
        normalizedOptionName.indexOf("color") !== -1 ||
        normalizedOptionName.indexOf("colour") !== -1
      );
    }

    function normalizeVariantOptionValue(value, optionName) {
      return normalizeKey(value || "", {
        stripColorPrefix: isColorOptionName(optionName),
      });
    }

    function findParentVariantById(targetVariantId) {
      var normalizedTargetVariantId = String(targetVariantId || "");

      return (
        productVariants.find(function (variant) {
          return String((variant && variant.id) || "") === normalizedTargetVariantId;
        }) || null
      );
    }

    function getCurrentParentVariant() {
      return (
        findParentVariantById(variantInput && variantInput.value) ||
        findParentVariantById(variantId) ||
        productVariants[0] ||
        null
      );
    }

    function findSourceGroupForProductOption(optionName, sourceGroups) {
      var targetOptionKey = normalizeKey(optionName || "");

      if (!targetOptionKey) {
        return null;
      }

      return (
        (sourceGroups || []).find(function (sourceGroup) {
          return getSourceGroupKeys(sourceGroup).indexOf(targetOptionKey) !== -1;
        }) || null
      );
    }

    function findParentVariantBySourceSelection(sourceGroups) {
      if (!productVariants.length || !productOptionNames.length) {
        return null;
      }

      var currentVariant = getCurrentParentVariant();
      var nextOptions = productOptionNames.map(function (optionName, optionIndex) {
        var matchingSourceGroup = findSourceGroupForProductOption(
          optionName,
          sourceGroups,
        );

        if (matchingSourceGroup && matchingSourceGroup.select) {
          return matchingSourceGroup.select.value || "";
        }

        if (currentVariant && Array.isArray(currentVariant.options)) {
          return currentVariant.options[optionIndex] || "";
        }

        return "";
      });

      return (
        productVariants.find(function (variant) {
          if (!variant || !Array.isArray(variant.options)) {
            return false;
          }

          return nextOptions.every(function (optionValue, optionIndex) {
            return (
              normalizeVariantOptionValue(
                variant.options[optionIndex],
                productOptionNames[optionIndex],
              ) ===
              normalizeVariantOptionValue(
                optionValue,
                productOptionNames[optionIndex],
              )
            );
          });
        }) || null
      );
    }

    function syncParentVariantFromSource() {
      if (!variantInput || !state.sourceRoot) {
        return;
      }

      var matchedVariant = findParentVariantBySourceSelection(
        getSourceGroups(state.sourceRoot),
      );

      if (!matchedVariant || !matchedVariant.id) {
        return;
      }

      var matchedVariantId = String(matchedVariant.id);

      if (String(variantInput.value || "") !== matchedVariantId) {
        variantInput.value = matchedVariantId;
      }

      section.setAttribute("data-bundle-variant-id", matchedVariantId);
    }

    function findSourceRoot() {
      var localSourceRoot = section.querySelector(SOURCE_ROOT_SELECTOR);

      if (localSourceRoot) {
        return localSourceRoot;
      }

      var candidates = Array.prototype.slice.call(
        document.querySelectorAll(SOURCE_ROOT_SELECTOR),
      );

      if (!variantId) {
        return candidates[0] || null;
      }

      return (
        candidates.find(function (candidate) {
          return (
            String(
              candidate.getAttribute("data-simple-bundles-variant-id") || "",
            ) === String(variantId)
          );
        }) ||
        candidates[0] ||
        null
      );
    }

    function findMatchingSourceGroupIndex(groupConfig, sourceGroups) {
      var configKeys = getGroupConfigKeys(groupConfig);
      var matchIndex = -1;

      sourceGroups.some(function (sourceGroup, index) {
        return getSourceGroupKeys(sourceGroup).some(function (sourceKey) {
          if (configKeys.indexOf(sourceKey) !== -1) {
            matchIndex = index;
            return true;
          }

          return false;
        });
      });

      return matchIndex;
    }

    function markSourceGroupIgnored(sourceGroup) {
      if (!sourceGroup || !sourceGroup.select) {
        return;
      }

      sourceGroup.select.dataset.bundleBoardIgnore = "true";
      sourceGroup.select.disabled = true;
      sourceGroup.select.classList.add(
        "product-page-section__bundle-source-ignored",
      );

      if (sourceGroup.labelNode) {
        sourceGroup.labelNode.classList.add(
          "product-page-section__bundle-source-ignored",
        );
      }
    }

    function buildRenderedGroups(sourceGroups) {
      var entries = [];
      var usedSourceIndices = {};

      (groupConfigs || []).forEach(function (groupConfig) {
        if (!groupConfig) {
          return;
        }

        var matchIndex = findMatchingSourceGroupIndex(
          groupConfig,
          sourceGroups,
        );
        var sourceGroup = matchIndex > -1 ? sourceGroups[matchIndex] : null;

        if (inferSelectionType(groupConfig) === "multiple") {
          if (matchIndex > -1) {
            markSourceGroupIgnored(sourceGroup);
            usedSourceIndices[matchIndex] = true;
          }

          entries.push({
            mode: "multiple",
            groupConfig: groupConfig,
          });
          return;
        }

        if (matchIndex > -1) {
          var hideSourceUi = shouldHideSourceGroupUi(groupConfig, sourceGroup);

          if (!state.isPublishedConfigurator && isGroupHiddenFromUi(groupConfig)) {
            entries.push({
              mode: "hidden-source",
              group: sourceGroup,
              groupConfig: groupConfig,
            });
            usedSourceIndices[matchIndex] = true;
            return;
          }

          entries.push({
            mode: "source",
            group: sourceGroup,
            groupConfig: groupConfig,
            hiddenInUi: hideSourceUi,
          });
          usedSourceIndices[matchIndex] = true;
        }
      });

      sourceGroups.forEach(function (sourceGroup, index) {
        if (
          usedSourceIndices[index] ||
          sourceGroup.select.dataset.bundleBoardIgnore === "true"
        ) {
          return;
        }

        entries.push({
          mode: "source",
          group: sourceGroup,
          groupConfig: getGroupConfig(sourceGroup, configMap),
        });
      });

      return entries;
    }

    function ensureMultipleSelectionState(groupIndex, cardConfig) {
      var cardKey = getCardKey(cardConfig);
      var defaultChoice = getDefaultAddOnChoice(cardConfig);

      if (!state.multipleSelections[groupIndex]) {
        state.multipleSelections[groupIndex] = {};
      }

      if (!state.multipleSelections[groupIndex][cardKey]) {
        state.multipleSelections[groupIndex][cardKey] = {
          selected:
            normalizeBoolean(cardConfig && cardConfig.default_selected) &&
            !!defaultChoice,
          variantId: defaultChoice ? defaultChoice.variantId : "",
          sizeValue: defaultChoice ? defaultChoice.sizeValue : "",
        };
      }

      return state.multipleSelections[groupIndex][cardKey];
    }

    function initializeMultipleSelections() {
      state.multipleSelections = {};
      state.hasMultipleGroups = false;

      state.renderedGroups.forEach(function (entry, groupIndex) {
        if (entry.mode !== "multiple") {
          return;
        }

        var visibleCards = getVisibleCards(entry.groupConfig.cards);

        if (!visibleCards.length) {
          return;
        }

        state.hasMultipleGroups = true;
        visibleCards.forEach(function (cardConfig) {
          ensureMultipleSelectionState(groupIndex, cardConfig);
        });
      });
    }

    function dispatchBubbledEvent(target, eventName) {
      if (!target || !eventName || typeof Event !== "function") {
        return;
      }

      target.dispatchEvent(
        new Event(eventName, {
          bubbles: true,
        }),
      );
    }

    function setSourceGroupValue(sourceGroup, nextValue, shouldDispatchEvents) {
      var select = sourceGroup && sourceGroup.select;
      var options = sourceGroup && sourceGroup.options ? sourceGroup.options : [];
      var matchedIndex = -1;

      if (!select) {
        return false;
      }

      options.some(function (optionNode, optionIndex) {
        if (String((optionNode && optionNode.value) || "") !== String(nextValue)) {
          return false;
        }

        matchedIndex = optionIndex;
        return true;
      });

      if (matchedIndex === -1) {
        return false;
      }

      Array.prototype.slice.call(select.options || []).forEach(function (
        optionNode,
        optionIndex,
      ) {
        optionNode.selected = optionIndex === matchedIndex;
      });

      select.selectedIndex = matchedIndex;
      select.value = nextValue;
      sourceGroup.options = Array.prototype.slice.call(select.options || []);

      if (shouldDispatchEvents !== false) {
        dispatchBubbledEvent(select, "input");
        dispatchBubbledEvent(select, "change");
      }

      return true;
    }

    function applySourceGroupPreset(renderedGroup) {
      var sourceGroup = renderedGroup && renderedGroup.group;
      var presetValues = getPresetValues(
        presetParamMap,
        getEntryPresetKeys(renderedGroup),
      );
      var matchedOption = findSourceOptionByPreset(
        sourceGroup,
        presetValues,
        renderedGroup && renderedGroup.groupConfig,
      );

      if (!sourceGroup || !matchedOption) {
        return false;
      }

      return setSourceGroupValue(sourceGroup, matchedOption.value);
    }

    function findDefaultSourceOption(renderedGroup) {
      return getDefaultVisibleSourceOption(renderedGroup);
    }

    function applySourceGroupDefaults() {
      var sourceGroupsChanged = false;

      state.renderedGroups.forEach(function (entry) {
        var sourceGroup = entry && entry.mode === "source" ? entry.group : null;
        var defaultOption = null;

        if (!sourceGroup || !sourceGroup.select) {
          return;
        }

        defaultOption = findDefaultSourceOption(entry);

        if (!defaultOption) {
          return;
        }

        if (String(sourceGroup.select.value || "") === String(defaultOption.value || "")) {
          return;
        }

        if (setSourceGroupValue(sourceGroup, defaultOption.value, false)) {
          sourceGroupsChanged = true;
        }
      });

      return {
        sourceGroupsChanged: sourceGroupsChanged,
      };
    }

    function stopSourceHydrationWatch() {
      if (state.sourceHydrationObserver) {
        state.sourceHydrationObserver.disconnect();
        state.sourceHydrationObserver = null;
      }

      if (state.sourceHydrationTimer) {
        window.clearTimeout(state.sourceHydrationTimer);
        state.sourceHydrationTimer = 0;
      }

      state.sourceHydrationAttempts = 0;
    }

    function isSourceUiReady() {
      if (!state.sourceRoot || !state.renderedGroups.length) {
        return false;
      }

      return state.renderedGroups.every(function (renderedGroup, groupIndex) {
        var sourceGroup = null;
        var selectableOptions = [];
        var selectedValue = "";
        var groupRoot = null;
        var renderedButtonCount = 0;

        if (
          !renderedGroup ||
          (renderedGroup.mode !== "source" &&
            renderedGroup.mode !== "hidden-source")
        ) {
          return true;
        }

        sourceGroup = renderedGroup.group;

        if (!sourceGroup || !sourceGroup.select) {
          return false;
        }

        sourceGroup.options = Array.prototype.slice.call(
          sourceGroup.select.options || [],
        );
        selectableOptions = renderedGroup.hiddenInUi
          ? getMeaningfulSourceOptions(sourceGroup)
          : getRenderableSourceOptions(
              sourceGroup,
              renderedGroup.groupConfig,
            );

        if (!selectableOptions.length) {
          return false;
        }

        selectedValue = String(sourceGroup.select.value || "");

        if (!selectedValue) {
          return false;
        }

        if (
          !selectableOptions.some(function (optionNode) {
            return String((optionNode && optionNode.value) || "") === selectedValue;
          })
        ) {
          return false;
        }

        if (renderedGroup.mode === "hidden-source" || renderedGroup.hiddenInUi) {
          return true;
        }

        groupRoot = getGroupRoot(groupIndex);

        if (!groupRoot) {
          return false;
        }

        renderedButtonCount = groupRoot.querySelectorAll(
          "[data-bundle-option-button]",
        ).length;

        return renderedButtonCount === selectableOptions.length;
      });
    }

    function scheduleSourceHydrationCheck(delay) {
      if (state.sourceHydrationTimer) {
        window.clearTimeout(state.sourceHydrationTimer);
      }

      state.sourceHydrationTimer = window.setTimeout(function () {
        state.sourceHydrationTimer = 0;
        runSourceHydrationCheck();
      }, typeof delay === "number" ? delay : 0);
    }

    function applyMultipleGroupPreset(renderedGroup, groupIndex) {
      var presetTokens = splitPresetValues(
        getPresetValues(presetParamMap, getEntryPresetKeys(renderedGroup)),
      );
      var visibleCards =
        renderedGroup && renderedGroup.groupConfig
          ? getVisibleCards(renderedGroup.groupConfig.cards)
          : [];
      var matchedSelections = {};
      var hasMatchedSelection = false;
      var shouldClearGroup = false;

      if (!presetTokens.length || !visibleCards.length) {
        return false;
      }

      presetTokens.forEach(function (tokenValue) {
        var token = parseMultiplePresetToken(tokenValue);
        var cardConfig = null;
        var matchedChoice = null;

        if (!token) {
          return;
        }

        if (token.clearAll) {
          shouldClearGroup = true;
          return;
        }

        cardConfig = findCardByKey(visibleCards, token.cardKey);

        if (!cardConfig || !hasAvailableAddOnChoice(cardConfig)) {
          return;
        }

        if (token.sizeKey) {
          matchedChoice = getAddOnChoiceFromSize(cardConfig, token.sizeValue);

          if (!matchedChoice || !matchedChoice.available) {
            return;
          }
        }

        matchedSelections[getCardKey(cardConfig)] = {
          cardConfig: cardConfig,
          choice: matchedChoice,
        };
        hasMatchedSelection = true;
      });

      if (!shouldClearGroup && !hasMatchedSelection) {
        return false;
      }

      visibleCards.forEach(function (cardConfig) {
        var selection = ensureMultipleSelectionState(groupIndex, cardConfig);
        var defaultChoice = getDefaultAddOnChoice(cardConfig);

        selection.selected = false;
        selection.variantId = defaultChoice ? defaultChoice.variantId : "";
        selection.sizeValue = defaultChoice ? defaultChoice.sizeValue : "";
      });

      Object.keys(matchedSelections).forEach(function (cardKey) {
        var presetSelection = matchedSelections[cardKey];
        var selection = ensureMultipleSelectionState(
          groupIndex,
          presetSelection.cardConfig,
        );
        var defaultChoice = getDefaultAddOnChoice(presetSelection.cardConfig);
        var choice = presetSelection.choice || defaultChoice;

        if (!choice) {
          return;
        }

        selection.selected = true;
        selection.variantId = choice.variantId || "";
        selection.sizeValue = choice.sizeValue || choice.value || "";
      });

      return true;
    }

    function applyPresetSelections() {
      var presetState = {
        sourceGroupsChanged: false,
      };

      if (!presetParamMap || !Object.keys(presetParamMap).length) {
        return presetState;
      }

      state.renderedGroups.forEach(function (entry, groupIndex) {
        if (!entry) {
          return;
        }

        if (entry.mode === "multiple") {
          applyMultipleGroupPreset(entry, groupIndex);
          return;
        }

        if (applySourceGroupPreset(entry)) {
          presetState.sourceGroupsChanged = true;
        }
      });

      return presetState;
    }

    function getDebugRawKeys(entry) {
      var keys = [];

      [
        entry && entry.groupConfig && entry.groupConfig.option_name,
        entry && entry.groupConfig && entry.groupConfig.heading,
        entry && entry.group && entry.group.propertyName,
        entry && entry.group && entry.group.label,
      ].forEach(function (value) {
        var nextValue = String(value || "").trim();

        if (nextValue && keys.indexOf(nextValue) === -1) {
          keys.push(nextValue);
        }
      });

      return keys;
    }

    function getSuggestedPresetKey(entry) {
      return (
        toReadablePresetToken(
          (entry &&
            entry.groupConfig &&
            (entry.groupConfig.heading || entry.groupConfig.option_name)) ||
            (entry &&
              entry.group &&
              (entry.group.label || entry.group.propertyName)) ||
            "",
        ) ||
        (getEntryPresetKeys(entry)[0] || "")
      );
    }

    function createPresetBaseUrl() {
      var currentUrl = null;
      var baseUrl = null;
      var variantParam = "";

      if (
        typeof window === "undefined" ||
        !window.location ||
        typeof window.URL !== "function"
      ) {
        return null;
      }

      currentUrl = new window.URL(window.location.href);
      baseUrl = new window.URL(currentUrl.origin + currentUrl.pathname);
      variantParam = currentUrl.searchParams.get("variant") || "";

      if (variantParam) {
        baseUrl.searchParams.set("variant", variantParam);
      }

      return baseUrl;
    }

    function buildPresetLinkRecord(entry, itemLabel, itemValue, options) {
      var settings = options || {};
      var paramKey = getSuggestedPresetKey(entry);
      var paramValue = String(itemValue || "").trim();
      var url = createPresetBaseUrl();

      if (!paramKey || !paramValue) {
        return null;
      }

      if (url) {
        url.searchParams.set(paramKey, paramValue);
      }

      return {
        group:
          (entry &&
            entry.groupConfig &&
            (entry.groupConfig.heading || entry.groupConfig.option_name)) ||
          "Option",
        label: itemLabel || paramValue,
        selectionType: settings.selectionType || "single",
        paramKey: paramKey,
        paramValue: paramValue,
        queryPair: paramKey + "=" + paramValue,
        url: url ? url.toString() : "",
      };
    }

    function buildSourceGroupPresetLinks(entry) {
      var sourceGroup = entry && entry.group;

      return ((sourceGroup && sourceGroup.options) || [])
        .filter(function (optionNode) {
          return !!(optionNode && optionNode.value);
        })
        .filter(function (optionNode) {
          return !/please select/i.test(optionNode.text || "");
        })
        .filter(function (optionNode) {
          return !isSourceOptionMarketHidden(optionNode, entry && entry.groupConfig);
        })
        .map(function (optionNode) {
          return buildPresetLinkRecord(
            entry,
            stripOptionSuffix(optionNode.text || optionNode.value),
            toReadablePresetToken(optionNode.value, {
              stripColorPrefix: true,
            }),
            {
              selectionType: "single",
            },
          );
        })
        .filter(Boolean);
    }

    function buildMultipleGroupPresetLinks(entry) {
      return getVisibleCards(entry && entry.groupConfig && entry.groupConfig.cards)
        .reduce(function (result, cardConfig) {
          var rawMatchValue = getCardPresetMatchValue(cardConfig);
          var baseValue = toReadablePresetToken(rawMatchValue, {
            stripColorPrefix: true,
          });
          var sizes = getAddOnSizeChoices(cardConfig);
          var cardTitle =
            (cardConfig && (cardConfig.title || cardConfig.option_value)) || "Add-on";

          if (!sizes.length) {
            var baseRecord = buildPresetLinkRecord(entry, cardTitle, baseValue, {
              selectionType: "multiple",
            });

            if (baseRecord) {
              result.push(baseRecord);
            }

            return result;
          }

          sizes.forEach(function (choice) {
            var sizeToken = toReadablePresetToken(choice.value);
            var sizeRecord = buildPresetLinkRecord(
              entry,
              cardTitle + " - " + choice.value,
              baseValue + ":" + sizeToken,
              {
                selectionType: "multiple",
              },
            );

            if (sizeRecord) {
              result.push(sizeRecord);
            }
          });

          return result;
        }, []);
    }

    function buildBundlePresetCopyLinks() {
      return state.renderedGroups.reduce(function (result, entry) {
        if (!entry) {
          return result;
        }

        if (entry.mode === "multiple") {
          return result.concat(buildMultipleGroupPresetLinks(entry));
        }

        return result.concat(buildSourceGroupPresetLinks(entry));
      }, []);
    }

    function buildSourceGroupPresetDebugEntry(entry) {
      var sourceGroup = entry && entry.group;
      var suggestedKey = getSuggestedPresetKey(entry);

      return {
        selectionType: "single",
        label:
          (entry &&
            entry.groupConfig &&
            (entry.groupConfig.heading || entry.groupConfig.option_name)) ||
          (sourceGroup && (sourceGroup.label || sourceGroup.propertyName)) ||
          "Option",
        suggestedParamKey: suggestedKey,
        acceptedParamKeys: getEntryPresetKeys(entry),
        acceptedRawKeys: getDebugRawKeys(entry),
        options: ((sourceGroup && sourceGroup.options) || [])
          .filter(function (optionNode) {
            return !!(optionNode && optionNode.value);
          })
          .filter(function (optionNode) {
            return !/please select/i.test(optionNode.text || "");
          })
          .filter(function (optionNode) {
            return !isSourceOptionMarketHidden(optionNode, entry && entry.groupConfig);
          })
          .map(function (optionNode) {
            var suggestedValue = toReadablePresetToken(optionNode.value, {
              stripColorPrefix: true,
            });

            return {
              label: stripOptionSuffix(optionNode.text || optionNode.value),
              rawValue: optionNode.value,
              rawText: String(optionNode.text || "").trim(),
              urlValue: suggestedValue,
              normalizedValue: normalizeKey(optionNode.value, {
                stripColorPrefix: true,
              }),
              example: suggestedKey
                ? suggestedKey + "=" + suggestedValue
                : suggestedValue,
            };
          }),
      };
    }

    function buildMultipleGroupPresetDebugEntry(entry) {
      var suggestedKey = getSuggestedPresetKey(entry);

      return {
        selectionType: "multiple",
        label:
          (entry &&
            entry.groupConfig &&
            (entry.groupConfig.heading || entry.groupConfig.option_name)) ||
          "Add-on",
        suggestedParamKey: suggestedKey,
        acceptedParamKeys: getEntryPresetKeys(entry),
        acceptedRawKeys: getDebugRawKeys(entry),
        cards: getVisibleCards(entry && entry.groupConfig && entry.groupConfig.cards)
          .map(function (cardConfig) {
            var rawMatchValue = getCardPresetMatchValue(cardConfig);
            var suggestedValue = toReadablePresetToken(rawMatchValue, {
              stripColorPrefix: true,
            });
            var sizes = getAddOnSizeChoices(cardConfig).map(function (choice) {
              return {
                rawValue: choice.value,
                urlValue: toReadablePresetToken(choice.value),
                normalizedValue: normalizeKey(choice.value),
                available: !!choice.available,
              };
            });

            return {
              title: cardConfig && (cardConfig.title || cardConfig.option_value) || "Add-on",
              rawMatchSource: getCardPresetMatchSource(cardConfig),
              rawMatchValue: rawMatchValue,
              urlValue: suggestedValue,
              normalizedValue: getCardKey(cardConfig),
              sizeOptionName: (cardConfig && cardConfig.size_option_name) || "",
              sizes: sizes,
              example: suggestedKey
                ? suggestedKey +
                  "=" +
                  suggestedValue +
                  (sizes.length ? ":" + sizes[0].urlValue : "")
                : suggestedValue,
            };
          }),
      };
    }

    function buildBundlePresetDebugPayload() {
      return {
        productTitle:
          (section.querySelector(".product-page-section__title") || {})
            .textContent || document.title,
        productUrl: window.location.href,
        copyLinks: buildBundlePresetCopyLinks(),
        groups: state.renderedGroups.map(function (entry) {
          if (entry.mode === "multiple") {
            return buildMultipleGroupPresetDebugEntry(entry);
          }

          return buildSourceGroupPresetDebugEntry(entry);
        }),
      };
    }

    function logBundlePresetDebug() {
      var payload = null;

      if (
        !shouldLogBundlePresetDebug() ||
        section.dataset.bundlePresetDebugLogged === "true"
      ) {
        return;
      }

      payload = buildBundlePresetDebugPayload();
      section.dataset.bundlePresetDebugLogged = "true";
      section.aerofoilsBundlePresetDebug = payload;
      window.AerofoilsBundlePresetDebug = payload;
      window.AerofoilsBundlePresetLinks = payload.copyLinks || [];
      window.AerofoilsBundlePresetLinksText = (payload.copyLinks || [])
        .map(function (entry) {
          return entry.url;
        })
        .join("\n");

      console.groupCollapsed(
        "[Bundle preset debug]",
        (payload && payload.productTitle) || "Bundle product",
      );
      console.log(
        "Copy-ready links available at window.AerofoilsBundlePresetLinks and window.AerofoilsBundlePresetLinksText",
      );
      console.table(payload.copyLinks || []);
      console.log(payload);
      console.groupEnd();
    }

    function getGroupRoot(groupIndex) {
      return root.querySelector(
        '[data-bundle-group-index="' + groupIndex + '"]',
      );
    }

    function syncMultipleGroup(groupRoot, renderedGroup, groupIndex) {
      var cards =
        renderedGroup && renderedGroup.groupConfig
          ? getVisibleCards(renderedGroup.groupConfig.cards)
          : [];

      cards.forEach(function (cardConfig) {
        var cardKey = getCardKey(cardConfig);
        var selection = ensureMultipleSelectionState(groupIndex, cardConfig);
        var cardRoot = groupRoot.querySelector(
          '[data-bundle-card-key="' + cardKey + '"]',
        );
        var toggleButton =
          cardRoot && cardRoot.querySelector("[data-bundle-addon-toggle]");
        var toggleIcon =
          cardRoot && cardRoot.querySelector("[data-bundle-addon-toggle-icon]");
        var priceNode =
          cardRoot && cardRoot.querySelector("[data-bundle-addon-price]");
        var defaultChoice = getDefaultAddOnChoice(cardConfig);
        var selectedVariant = getSelectedAddOnVariant(cardConfig, selection);

        if (!cardRoot) {
          return;
        }

        if (!defaultChoice) {
          selection.selected = false;
          selection.variantId = "";
          selection.sizeValue = "";
        }

        cardRoot.classList.toggle("is-selected", !!selection.selected);
        cardRoot.classList.toggle("is-disabled", !defaultChoice);

        if (toggleButton) {
          toggleButton.classList.toggle("is-selected", !!selection.selected);
          toggleButton.disabled = !defaultChoice;
          toggleButton.setAttribute(
            "aria-pressed",
            selection.selected ? "true" : "false",
          );
        }

        if (toggleIcon) {
          toggleIcon.innerHTML = selection.selected ? CHECK_ICON : "";
        }

        if (priceNode) {
          priceNode.textContent = getAddOnPriceMarkup(
            cardConfig,
            selection,
            priceFormatter,
          );
        }

        Array.prototype.slice
          .call(cardRoot.querySelectorAll("[data-bundle-addon-size-button]"))
          .forEach(function (sizeButton) {
            var sizeValue =
              sizeButton.getAttribute("data-bundle-addon-size-value") || "";
            var isAvailable =
              sizeButton.getAttribute("data-bundle-addon-available") !==
              "false";
            var isActive =
              normalizeKey(sizeValue) === normalizeKey(selection.sizeValue);

            sizeButton.classList.toggle("is-active", isActive);
            sizeButton.classList.toggle("is-unavailable", !isAvailable);
            sizeButton.disabled = !isAvailable;
            sizeButton.setAttribute(
              "aria-pressed",
              isActive ? "true" : "false",
            );
          });

        if (!selection.variantId && selectedVariant) {
          selection.variantId = String(selectedVariant.id || "");
        }
      });
    }

    function updateHiddenSelectionInput() {
      if (!state.sourceRoot) {
        return;
      }

      if (state.isPublishedConfigurator) {
        var publishedPayload = buildPublishedSelectionPayload();
        var publishedDisplay = buildPublishedDisplaySummary();

        if (!publishedPayload || !publishedPayload.s.length) {
          return;
        }

        ensureHiddenPropertyInput(
          "_aerofoils_config",
          JSON.stringify(publishedPayload),
        );
        ensureHiddenPropertyInput("_aerofoils_display", publishedDisplay);
        return;
      }

      var values = getSourceGroups(state.sourceRoot)
        .map(function (group) {
          return group.select.value;
        })
        .filter(Boolean);

      if (!values.length) {
        return;
      }

      var hiddenInput = state.sourceRoot.querySelector(
        'input[name="properties[_bundle_selection]"]',
      );

      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = "properties[_bundle_selection]";
        state.sourceRoot.appendChild(hiddenInput);
      }

      hiddenInput.value = values.join(" <> ");
    }

    function shouldIncludeSourceOption(optionNode, groupConfig) {
      if (!optionNode || !optionNode.value) {
        return false;
      }

      if (/please select/i.test(optionNode.text || "")) {
        return false;
      }

      if (isGroupHiddenFromUi(groupConfig)) {
        return true;
      }

      if (hasCards(groupConfig)) {
        return true;
      }

      var rawPrice = optionNode.dataset ? optionNode.dataset.price : "";

      if (rawPrice !== "") {
        var numericPrice = Number(rawPrice);

        if (!isNaN(numericPrice) && numericPrice <= 0) {
          return false;
        }
      }

      return true;
    }

    function getConfiguredIncludedItems(cardConfig) {
      return Array.isArray(cardConfig && cardConfig.included_items)
        ? cardConfig.included_items
        : [];
    }

    function getActiveSpecificationCardHandles() {
      return state.renderedGroups.reduce(function (result, entry, groupIndex) {
        if (!entry || !entry.groupConfig) {
          return result;
        }

        if (entry.mode === "multiple") {
          getVisibleCards(entry.groupConfig.cards).forEach(function (cardConfig) {
            var selection = ensureMultipleSelectionState(groupIndex, cardConfig);
            var cardHandle = getCardHandle(cardConfig);

            if (selection.selected && cardHandle && result.indexOf(cardHandle) === -1) {
              result.push(cardHandle);
            }
          });

          return result;
        }

        var sourceGroup = entry.group;
        var selectedValue =
          sourceGroup && sourceGroup.select ? sourceGroup.select.value : "";
        var selectedCard = findMatchingCard(
          entry.groupConfig.cards,
          selectedValue,
        );
        var selectedHandle = getCardHandle(selectedCard);

        if (selectedHandle && result.indexOf(selectedHandle) === -1) {
          result.push(selectedHandle);
        }

        return result;
      }, []);
    }

    function syncSpecificationGroups() {
      if (!specificationsApi || !specificationGroups.length) {
        return;
      }

      specificationsApi.syncGroups(
        specificationGroups,
        getActiveSpecificationCardHandles(),
      );
    }

    function buildConfiguredIncludedItem(itemConfig, itemKey) {
      var title = String((itemConfig && itemConfig.title) || "").trim();

      if (!title) {
        return null;
      }

      return {
        key: itemKey,
        title: title,
        quantity: String((itemConfig && itemConfig.quantity) || "").trim(),
        url: String((itemConfig && itemConfig.url) || "").trim(),
        imageUrl: String((itemConfig && itemConfig.image_url) || "").trim(),
      };
    }

    function getIncludedItemMatchKey(item) {
      return normalizeKey((item && (item.url || item.title || item.key)) || "", {
        stripColorPrefix: true,
      });
    }

    function pushUniqueIncludedItem(items, seenItems, item) {
      var itemMatchKey = getIncludedItemMatchKey(item);

      if (!item) {
        return;
      }

      if (itemMatchKey && seenItems[itemMatchKey]) {
        return;
      }

      if (itemMatchKey) {
        seenItems[itemMatchKey] = true;
      }

      items.push(item);
    }

    function buildConfiguredIncludedItems(cardConfig, itemKeyPrefix) {
      return getConfiguredIncludedItems(cardConfig).reduce(function (
        result,
        itemConfig,
        itemIndex,
      ) {
        var nextItem = buildConfiguredIncludedItem(
          itemConfig,
          itemKeyPrefix + "-included-" + itemIndex,
        );

        if (nextItem) {
          result.push(nextItem);
        }

        return result;
      }, []);
    }

    function buildIncludedCardFallbackItem(cardConfig, itemKey, fallbackTitle) {
      var linkedProduct =
        cardConfig && cardConfig.product ? cardConfig.product : null;
      var title =
        (linkedProduct && linkedProduct.title) ||
        String(fallbackTitle || "").trim() ||
        (cardConfig && (cardConfig.title || cardConfig.option_value)) ||
        "";

      if (!title) {
        return null;
      }

      return {
        key: itemKey,
        title: title,
        quantity: "",
        url: (linkedProduct && linkedProduct.url) || "",
        imageUrl:
          getCardIncludedImageUrl(cardConfig) ||
          String((linkedProduct && linkedProduct.image_url) || "").trim(),
      };
    }

    function buildIncludedSourceFallbackItem(
      selectedOption,
      cardConfig,
      groupIndex,
    ) {
      return buildIncludedCardFallbackItem(
        cardConfig,
        "source-" +
          groupIndex +
          "-" +
          normalizeKey(selectedOption.value, {
            stripColorPrefix: true,
          }),
        stripOptionSuffix(selectedOption.text || selectedOption.value),
      );
    }

    function buildIncludedSourceItems(renderedGroup, groupIndex) {
      var sourceGroup = renderedGroup && renderedGroup.group;
      var groupConfig = renderedGroup && renderedGroup.groupConfig;
      var selectedOption =
        sourceGroup && sourceGroup.select
          ? sourceGroup.select.options[sourceGroup.select.selectedIndex]
          : null;

      if (!shouldIncludeSourceOption(selectedOption, groupConfig)) {
        return [];
      }

      var cardConfig = findMatchingCard(
        groupConfig ? groupConfig.cards : [],
        selectedOption.value,
      );
      var itemKeyBase =
        "source-" +
        groupIndex +
        "-" +
        normalizeKey(selectedOption.value, {
          stripColorPrefix: true,
        });
      var configuredItems = buildConfiguredIncludedItems(
        cardConfig,
        itemKeyBase,
      );
      var fallbackItem = buildIncludedSourceFallbackItem(
        selectedOption,
        cardConfig,
        groupIndex,
      );
      var items = [];
      var seenItems = {};

      if (fallbackItem) {
        pushUniqueIncludedItem(items, seenItems, fallbackItem);
      }

      configuredItems.forEach(function (item) {
        pushUniqueIncludedItem(items, seenItems, item);
      });

      return items;
    }

    function buildIncludedMultipleItems(renderedGroup, groupIndex) {
      var groupConfig = renderedGroup && renderedGroup.groupConfig;
      var cards = Array.isArray(groupConfig && groupConfig.cards)
        ? groupConfig.cards
        : [];

      return cards.reduce(function (result, cardConfig) {
        var selection = ensureMultipleSelectionState(groupIndex, cardConfig);
        var itemKeyBase = "addon-" + groupIndex + "-" + getCardKey(cardConfig);
        var fallbackItem = buildIncludedCardFallbackItem(
          cardConfig,
          itemKeyBase,
          "",
        );
        var configuredItems = buildConfiguredIncludedItems(
          cardConfig,
          itemKeyBase,
        );
        var nestedItems = [];
        var seenItems = {};

        if (!selection.selected) {
          return result;
        }

        if (fallbackItem) {
          pushUniqueIncludedItem(nestedItems, seenItems, fallbackItem);
        }

        configuredItems.forEach(function (item) {
          pushUniqueIncludedItem(nestedItems, seenItems, item);
        });

        return result.concat(nestedItems);
      }, []);
    }

    function formatIncludedQuantityPrefix(quantityValue) {
      var quantity = String(quantityValue == null ? "" : quantityValue).trim();

      if (!quantity) {
        return "";
      }

      if (/x/i.test(quantity) || quantity.indexOf("×") !== -1) {
        return quantity;
      }

      return quantity + "x";
    }

    function formatIncludedItemLabel(item) {
      var title = String((item && item.title) || "").trim();
      var quantityPrefix = formatIncludedQuantityPrefix(item && item.quantity);

      if (quantityPrefix && title) {
        return quantityPrefix + " " + title;
      }

      return quantityPrefix || title;
    }

    function collectIncludedItems() {
      return state.renderedGroups.reduce(function (result, entry, groupIndex) {
        if (entry && entry.mode === "multiple") {
          buildIncludedMultipleItems(entry, groupIndex).forEach(function (
            nextItem,
          ) {
            if (nextItem) {
              result.push(nextItem);
            }
          });

          return result;
        }

        buildIncludedSourceItems(entry, groupIndex).forEach(function (nextItem) {
          if (nextItem) {
            result.push(nextItem);
          }
        });

        return result;
      }, []);
    }

    function renderIncludedItemMarkup(item) {
      var label = formatIncludedItemLabel(item);

      if (!item || !label) {
        return "";
      }

      var openingTag = item.url
        ? '<a class="product-page-section__included-item" href="' +
          escapeHtml(item.url) +
          '">'
        : '<div class="product-page-section__included-item">';
      var closingTag = item.url ? "</a>" : "</div>";

      return [
        openingTag,
        '<div class="product-page-section__included-media">',
        item.imageUrl
          ? '<img class="product-page-section__included-image" src="' +
            escapeHtml(item.imageUrl) +
            '" alt="' +
            escapeHtml(label) +
            '" loading="lazy">'
          : "",
        "</div>",
        '<div class="product-page-section__included-copy">',
        '<p class="product-page-section__included-title">',
        escapeHtml(label),
        "</p>",
        "</div>",
        closingTag,
      ].join("");
    }

    function scheduleIncludedCollapseSync() {
      if (state.includedCollapseFrame) {
        window.cancelAnimationFrame(state.includedCollapseFrame);
      }

      state.includedCollapseFrame = window.requestAnimationFrame(function () {
        state.includedCollapseFrame = 0;
        syncIncludedCollapse();
      });
    }

    function getIncludedExtraItems(itemNodes, columnCount) {
      return itemNodes.filter(function (_, index) {
        return index >= columnCount;
      });
    }

    function updateIncludedToggleState() {
      if (includedToggleButton) {
        includedToggleButton.setAttribute(
          "aria-expanded",
          state.includedExpanded ? "true" : "false",
        );
      }

      if (includedToggleLabel) {
        includedToggleLabel.textContent = state.includedExpanded
          ? labels.includedShowLess
          : labels.includedShowAll;
      }
    }

    function resetIncludedCollapse() {
      state.includedExpanded = false;

      if (includedGridShell) {
        includedGridShell.style.maxHeight = "";
      }

      if (includedToggleWrap) {
        includedToggleWrap.hidden = true;
      }

      updateIncludedToggleState();

      if (includedBlock) {
        includedBlock.classList.remove("is-collapsible", "is-expanded");
      }

      Array.prototype.slice
        .call(
          includedGrid.querySelectorAll(
            ".product-page-section__included-item.is-beyond-first-row, .product-page-section__included-item.is-collapse-hidden",
          ),
        )
        .forEach(function (node) {
          node.classList.remove("is-beyond-first-row");
          node.classList.remove("is-collapse-hidden");
        });
    }

    function getIncludedColumnCount() {
      if (!includedGrid) {
        return 0;
      }

      var templateColumns = window.getComputedStyle(includedGrid)
        .gridTemplateColumns;
      var columns = templateColumns
        ? templateColumns
            .split(" ")
            .map(function (value) {
              return value.trim();
            })
            .filter(Boolean)
        : [];

      return columns.length || 1;
    }
    function toggleIncludedCollapse() {
      if (!includedBlock || !includedGrid) {
        return;
      }

      var itemNodes = Array.prototype.slice.call(
        includedGrid.querySelectorAll(".product-page-section__included-item"),
      );
      var columnCount = getIncludedColumnCount();
      var extraItems = getIncludedExtraItems(itemNodes, columnCount);

      if (!extraItems.length) {
        return;
      }

      state.includedExpanded = !state.includedExpanded;
      updateIncludedToggleState();
      includedBlock.classList.add("is-collapsible", "is-expanded");
      includedBlock.classList.toggle("is-expanded", state.includedExpanded);

      extraItems.forEach(function (node) {
        node.classList.toggle("is-collapse-hidden", !state.includedExpanded);
      });
    }

    function syncIncludedCollapse() {
      if (!includedBlock || !includedGrid) {
        return;
      }

      var itemNodes = Array.prototype.slice.call(
        includedGrid.querySelectorAll(".product-page-section__included-item"),
      );

      if (!itemNodes.length) {
        resetIncludedCollapse();
        return;
      }

      var columnCount = getIncludedColumnCount();
      var hasMultipleRows = itemNodes.length > columnCount;
      var extraItems = getIncludedExtraItems(itemNodes, columnCount);

      if (!hasMultipleRows) {
        resetIncludedCollapse();
        return;
      }

      itemNodes.forEach(function (node, index) {
        node.classList.toggle("is-beyond-first-row", index >= columnCount);
      });

      extraItems.forEach(function (node) {
        node.classList.toggle("is-collapse-hidden", !state.includedExpanded);
      });

      if (includedToggleWrap) {
        includedToggleWrap.hidden = false;
      }

      updateIncludedToggleState();

      includedBlock.classList.add("is-collapsible");
      includedBlock.classList.toggle("is-expanded", state.includedExpanded);
    }

    function syncIncludedBlock() {
      if (!includedBlock || !includedGrid) {
        return;
      }

      var items = collectIncludedItems();

      if (!items.length) {
        includedGrid.innerHTML = "";
        resetIncludedCollapse();
        includedBlock.hidden = true;
        return;
      }

      includedGrid.innerHTML = items.map(renderIncludedItemMarkup).join("");
      includedBlock.hidden = false;
      scheduleIncludedCollapseSync();
    }

    function syncPricePreview() {
      if (!state.sourceRoot) {
        return;
      }

      if (state.isPublishedConfigurator) {
        var publishedPayload = buildPublishedSelectionPayload();
        var resolvedComponents = resolveRuntimeExpansion(publishedPayload);
        var publishedTotal = resolvedComponents
          ? getRuntimeComponentsTotal(resolvedComponents, configuratorCountry)
          : 0;

        publishedTotal += state.renderedGroups.reduce(function (
          result,
          entry,
          groupIndex,
        ) {
          if (!entry || entry.mode !== "multiple") {
            return result;
          }

          return (
            result +
            getVisibleCards(entry.groupConfig.cards).reduce(function (
              cardTotal,
              cardConfig,
            ) {
              var selection = ensureMultipleSelectionState(
                groupIndex,
                cardConfig,
              );

              if (!selection.selected) {
                return cardTotal;
              }

              var selectedVariant = getSelectedAddOnVariant(
                cardConfig,
                selection,
              );
              var optionPrice = selectedVariant
                ? Number(selectedVariant.price || 0)
                : 0;

              if (isNaN(optionPrice) || optionPrice <= 0) {
                return cardTotal;
              }

              return cardTotal + optionPrice;
            }, 0)
          );
        }, 0);

        if (publishedTotal <= 0) {
          return;
        }

        var formattedPublishedTotal = priceFormatter(publishedTotal);

        section.aerofoilsBundlePricePreview = {
          total: publishedTotal,
          formatted: formattedPublishedTotal,
          compareTotal: 0,
          compareFormatted: "",
        };

        priceNodes.forEach(function (priceNode) {
          priceNode.textContent = formattedPublishedTotal;
        });

        comparePriceNodes.forEach(function (comparePriceNode) {
          comparePriceNode.textContent = "";
          comparePriceNode.classList.add("is-hidden");
        });

        section.dispatchEvent(
          new CustomEvent("aerofoils:bundle-price-change", {
            bubbles: true,
            detail: section.aerofoilsBundlePricePreview,
          }),
        );
        return;
      }

      var currentParentVariant = getCurrentParentVariant();
      var parentPrice = currentParentVariant
        ? convertSubunitsToDisplayUnits(currentParentVariant.price, priceFormatter)
        : 0;
      var parentCompareAtPrice = currentParentVariant
        ? convertSubunitsToDisplayUnits(
            currentParentVariant.compare_at_price,
            priceFormatter,
          )
        : 0;
      var total = parentPrice > 0
        ? parentPrice
        : getSourceGroups(state.sourceRoot).reduce(function (result, group) {
            var selectedOption = group.select.options[group.select.selectedIndex];
            var optionPrice = getOptionDatasetNumber(selectedOption, "price");

            if (isNaN(optionPrice)) {
              return result;
            }

            return result + optionPrice;
          }, 0);

      total += state.renderedGroups.reduce(function (result, entry, groupIndex) {
        if (!entry) {
          return result;
        }

        if (entry.mode === "multiple") {
          return (
            result +
            getVisibleCards(entry.groupConfig.cards).reduce(function (
              cardTotal,
              cardConfig,
            ) {
              var selection = ensureMultipleSelectionState(
                groupIndex,
                cardConfig,
              );

              if (!selection.selected) {
                return cardTotal;
              }

              var selectedVariant = getSelectedAddOnVariant(
                cardConfig,
                selection,
              );
              var optionPrice = selectedVariant
                ? Number(selectedVariant.price || 0)
                : 0;

              if (isNaN(optionPrice) || optionPrice <= 0) {
                return cardTotal;
              }

              return cardTotal + optionPrice;
            }, 0)
          );
        }

        if (entry.mode !== "source") {
          return result;
        }

        if (
          parentPrice > 0 &&
          isParentVariantBundleGroup(entry.group, productOptionNames)
        ) {
          return result;
        }

        var sourceGroup = entry.group;
        var selectedOption =
          sourceGroup && sourceGroup.select
            ? sourceGroup.select.options[sourceGroup.select.selectedIndex]
            : null;
        var selectedCard = findMatchingCard(
          entry.groupConfig ? entry.groupConfig.cards : [],
          selectedOption ? selectedOption.value : "",
        );
        var marketAwareValue = getSingleGroupMarketAwareValue(
          selectedOption,
          selectedCard,
          entry,
          parentPrice > 0,
        );

        if (!isNaN(marketAwareValue)) {
          return result + marketAwareValue;
        }

        var legacyOptionPrice = getOptionDatasetNumber(selectedOption, "price");

        if (!isNaN(legacyOptionPrice) && legacyOptionPrice > 0) {
          return result + legacyOptionPrice;
        }

        return result;
      }, 0);

      if (total <= 0) {
        return;
      }

      var formattedTotal = priceFormatter(total);
      var compareTotal = 0;
      var formattedCompareTotal = "";

      if (
        parentCompareAtPrice > parentPrice
        && parentPrice > 0
        && total > 0
      ) {
        compareTotal = total + (parentCompareAtPrice - parentPrice);

        if (compareTotal > total) {
          formattedCompareTotal = priceFormatter(compareTotal);
        }
      }

      section.aerofoilsBundlePricePreview = {
        total: total,
        formatted: formattedTotal,
        compareTotal: compareTotal,
        compareFormatted: formattedCompareTotal,
      };

      priceNodes.forEach(function (priceNode) {
        priceNode.textContent = formattedTotal;
      });

      comparePriceNodes.forEach(function (comparePriceNode) {
        comparePriceNode.textContent = formattedCompareTotal;
        comparePriceNode.classList.toggle("is-hidden", formattedCompareTotal === "");
      });

      section.dispatchEvent(
        new CustomEvent("aerofoils:bundle-price-change", {
          bubbles: true,
          detail: section.aerofoilsBundlePricePreview,
        }),
      );
    }

    function syncGroupModal(groupRoot, renderedGroup, selectedValue) {
      var dialog = groupRoot.querySelector("[data-bundle-modal]");
      var groupConfig = renderedGroup && renderedGroup.groupConfig;
      var modalType = getModalType(groupConfig);
      var activeCard = findMatchingCard(
        groupConfig ? groupConfig.cards : [],
        selectedValue,
      );
      var activeKey = normalizeKey(selectedValue, { stripColorPrefix: true });
      var descriptionNode =
        dialog && dialog.querySelector("[data-bundle-modal-description]");

      if (!dialog || !modalType) {
        return;
      }

      if (descriptionNode) {
        var nextDescription =
          (activeCard && activeCard.modal_description) ||
          (groupConfig && groupConfig.modal_content) ||
          "";
        descriptionNode.innerHTML = escapeHtml(nextDescription).replace(
          /\n/g,
          "<br>",
        );
        descriptionNode.hidden = nextDescription === "";
      }

      Array.prototype.slice
        .call(dialog.querySelectorAll("[data-bundle-modal-option]"))
        .forEach(function (node) {
          node.classList.toggle(
            "is-active",
            node.getAttribute("data-bundle-modal-option") === activeKey,
          );
        });

      syncRatingBars(dialog);
    }

    function syncDeferredInteractiveFeatures() {
      state.renderedGroups.forEach(function (renderedGroup, groupIndex) {
        var groupRoot = getGroupRoot(groupIndex);
        var sourceGroup =
          renderedGroup && renderedGroup.mode === "source"
            ? renderedGroup.group
            : null;

        if (!groupRoot || !renderedGroup || !sourceGroup || !sourceGroup.select) {
          return;
        }

        syncGroupModal(groupRoot, renderedGroup, sourceGroup.select.value);
      });

      publishBundleGalleryMedia();
    }

    function syncDeferredBelowFoldFeatures() {
      syncIncludedBlock();
      syncSpecificationGroups();
    }

    function ensureDeferredInteractiveFeatures(options) {
      var settings = options || {};
      var shouldSync = settings.skipSync !== true;

      state.deferredInteractiveReady = true;

      if (shouldSync) {
        syncDeferredInteractiveFeatures();
      }
    }

    function ensureDeferredBelowFoldFeatures() {
      if (!state.deferredBelowFoldReady) {
        state.deferredBelowFoldReady = true;

        if (includedGrid && typeof ResizeObserver === "function") {
          includedGridObserver = new ResizeObserver(function () {
            scheduleIncludedCollapseSync();
          });

          includedGridObserver.observe(includedGrid);
        }

        if (!includedResizeHandler) {
          includedResizeHandler = scheduleIncludedCollapseSync;
          window.addEventListener("resize", includedResizeHandler);
        }
      }

      syncDeferredBelowFoldFeatures();
    }

    function scheduleDeferredInteractiveFeatures() {
      if (state.deferredInteractiveScheduled) {
        return;
      }

      state.deferredInteractiveScheduled = true;

      function run() {
        runWhenIdle(function () {
          state.deferredInteractiveScheduled = false;
          ensureDeferredInteractiveFeatures();
        }, 1400);
      }

      if (
        window.Aerofoils &&
        typeof window.Aerofoils.afterPageLoad === "function"
      ) {
        window.Aerofoils.afterPageLoad(run);
        return;
      }

      if (document.readyState === "complete") {
        run();
        return;
      }

      window.addEventListener("load", run, { once: true });
    }

    function observeDeferredBelowFoldFeatures() {
      if (state.deferredBelowFoldObserved || state.deferredBelowFoldReady) {
        return;
      }

      state.deferredBelowFoldObserved = true;

      if (
        !window.Aerofoils ||
        typeof window.Aerofoils.whenSectionVisible !== "function"
      ) {
        ensureDeferredBelowFoldFeatures();
        return;
      }

      var observedTarget = false;

      function observeTarget(target) {
        if (!target) {
          return;
        }

        observedTarget = true;
        state.deferredBelowFoldCleanupFns.push(
          window.Aerofoils.whenSectionVisible(
            target,
            function () {
              ensureDeferredBelowFoldFeatures();
            },
            {
              rootMargin: "420px 0px",
              threshold: 0.01,
            },
          ),
        );
      }

      observeTarget(includedBlock);
      specificationGroups.forEach(function (group) {
        observeTarget(group && group.root);
      });

      if (!observedTarget) {
        ensureDeferredBelowFoldFeatures();
      }
    }

    function collectBundleGalleryMedia() {
      var media = [];
      var seen = {};

      state.renderedGroups.forEach(function (entry, groupIndex) {
        if (!entry) {
          return;
        }

        if (entry.mode === "multiple") {
          getVisibleCards(entry.groupConfig.cards).forEach(function (
            cardConfig,
          ) {
            var selection = ensureMultipleSelectionState(groupIndex, cardConfig);

            if (!selection.selected) {
              return;
            }

            appendCardGalleryMedia(media, seen, cardConfig);
          });
          return;
        }

        var sourceGroup = entry.group;
        var selectedValue =
          sourceGroup && sourceGroup.select ? sourceGroup.select.value : "";
        var selectedCard = findMatchingCard(
          entry.groupConfig ? entry.groupConfig.cards : [],
          selectedValue,
        );

        if (!selectedCard) {
          return;
        }

        appendCardGalleryMedia(media, seen, selectedCard);
      });

      return media;
    }

    function collectBundleModel3dUrl() {
      var modelUrl = "";

      state.renderedGroups.forEach(function (entry, groupIndex) {
        if (!entry || modelUrl) {
          return;
        }

        if (entry.mode === "multiple") {
          getVisibleCards(entry.groupConfig.cards).some(function (cardConfig) {
            var selection = ensureMultipleSelectionState(groupIndex, cardConfig);

            if (selection.selected) {
              modelUrl = getCardModel3dUrl(cardConfig);
            }

            return Boolean(modelUrl);
          });
          return;
        }

        var sourceGroup = entry.group;
        var selectedValue =
          sourceGroup && sourceGroup.select ? sourceGroup.select.value : "";
        var selectedCard = findMatchingCard(
          entry.groupConfig ? entry.groupConfig.cards : [],
          selectedValue,
        );

        modelUrl = getCardModel3dUrl(selectedCard);
      });

      return modelUrl;
    }

    function publishBundleGalleryMedia() {
      var media = collectBundleGalleryMedia();
      var model3dUrl = collectBundleModel3dUrl();

      section.aerofoilsBundleGalleryMedia = media;
      section.aerofoilsBundleModel3dUrl = model3dUrl;
      section.dispatchEvent(
        new CustomEvent("aerofoils:bundle-gallery-change", {
          bubbles: true,
          detail: {
            sectionId: section.id || "",
            media: media,
            model3dUrl: model3dUrl,
          },
        }),
      );
    }

    function syncFromSource() {
      if (!state.sourceRoot) {
        return;
      }

      if (!state.renderedGroups.length) {
        return;
      }

      state.renderedGroups.forEach(function (renderedGroup, groupIndex) {
        var groupRoot = getGroupRoot(groupIndex);

        if (!groupRoot || !renderedGroup) {
          return;
        }

        if (renderedGroup.mode === "multiple") {
          syncMultipleGroup(groupRoot, renderedGroup, groupIndex);
          return;
        }

        var sourceGroup = renderedGroup.group;

        if (!sourceGroup || !sourceGroup.select) {
          return;
        }

        sourceGroup.options = Array.prototype.slice.call(
          sourceGroup.select.options || [],
        );

        Array.prototype.slice
          .call(groupRoot.querySelectorAll("[data-bundle-option-button]"))
          .forEach(function (button) {
            var optionValue = button.getAttribute("data-bundle-value") || "";
            var sourceOption = sourceGroup.options.find(function (option) {
              return option.value === optionValue;
            });
            var isSelected = sourceGroup.select.value === optionValue;
            var isDisabled = !sourceOption || sourceOption.disabled;

            button.classList.toggle("is-active", isSelected);
            button.classList.toggle("is-unavailable", isDisabled);
            button.disabled = isDisabled;
            button.setAttribute("aria-pressed", isSelected ? "true" : "false");
          });

        syncSingleGroupPriceLabels(
          groupRoot,
          renderedGroup,
          priceFormatter,
          productOptionNames,
          hasParentBasePrice,
          {
            isPublishedConfigurator: state.isPublishedConfigurator,
            getPublishedPriceMarkup: getPublishedPriceMarkup,
          },
        );

        if (state.deferredInteractiveReady) {
          syncGroupModal(groupRoot, renderedGroup, sourceGroup.select.value);
        }
      });

      syncParentVariantFromSource();
      updateHiddenSelectionInput();
      syncPricePreview();

      publishBundleGalleryMedia();

      if (state.deferredBelowFoldReady) {
        syncIncludedBlock();
        syncSpecificationGroups();
      }
    }

    function bindSourceSelects() {
      getSourceGroups(state.sourceRoot).forEach(function (group) {
        if (group.select.dataset.bundleBoardBound === "true") {
          return;
        }

        group.select.dataset.bundleBoardBound = "true";
        group.select.addEventListener("change", function () {
          if (state.hasUserInteractedWithBundle) {
            stopSourceHydrationWatch();
          }

          window.requestAnimationFrame(syncFromSource);
        });
      });
    }

    function readFieldValue(field) {
      if (!field || !field.name || field.disabled) {
        return null;
      }

      if (
        (field.type === "checkbox" || field.type === "radio") &&
        !field.checked
      ) {
        return null;
      }

      return field.value;
    }

    function assignItemField(item, fieldName, fieldValue) {
      if (fieldValue == null || fieldValue === "") {
        return;
      }

      if (fieldName === "id") {
        item.id = fieldValue;
        return;
      }

      if (fieldName === "quantity") {
        var parsedQuantity = Number(fieldValue);
        item.quantity =
          !isNaN(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
        return;
      }

      if (fieldName === "selling_plan") {
        item.selling_plan = fieldValue;
        return;
      }

      var propertyMatch = fieldName.match(/^properties\[(.*)\]$/);

      if (!propertyMatch) {
        return;
      }

      if (!item.properties) {
        item.properties = {};
      }

      item.properties[propertyMatch[1]] = fieldValue;
    }

    function collectFieldsIntoItem(scope, item) {
      if (!scope) {
        return;
      }

      Array.prototype.slice
        .call(
          scope.querySelectorAll("input[name], select[name], textarea[name]"),
        )
        .forEach(function (field) {
          assignItemField(item, field.name, readFieldValue(field));
        });
    }

    function buildMainBundleItem() {
      if (state.isPublishedConfigurator) {
        var publishedPayload = buildPublishedSelectionPayload();
        var publishedDisplay = buildPublishedDisplaySummary();
        var publishedVariantInput = form
          ? form.querySelector('[data-product-variant-id], [name="id"]')
          : null;

        if (!publishedPayload || !publishedPayload.s.length) {
          return {
            id: "",
            quantity: 1,
          };
        }

        return {
          id: publishedVariantInput ? publishedVariantInput.value : variantId,
          quantity: 1,
          properties: {
            _aerofoils_config: JSON.stringify(publishedPayload),
            _aerofoils_display: publishedDisplay,
          },
        };
      }

      var item = {
        id: "",
        quantity: 1,
        properties: {},
      };

      collectFieldsIntoItem(form, item);
      collectFieldsIntoItem(state.sourceRoot, item);

      if (!item.id && form) {
        var idInput = form.querySelector('[name="id"]');

        if (idInput) {
          item.id = idInput.value;
        }
      }

      if (Object.keys(item.properties || {}).length === 0) {
        delete item.properties;
      }

      return item;
    }

    function buildSelectedAddOnItems() {
      var parentVariantInput = form
        ? form.querySelector('[data-product-variant-id], [name="id"]')
        : null;
      var parentVariantId = parentVariantInput
        ? String(parentVariantInput.value || "")
        : String(variantId || "");

      return state.renderedGroups.reduce(function (result, entry, groupIndex) {
        if (entry.mode !== "multiple") {
          return result;
        }

        getVisibleCards(entry.groupConfig.cards).forEach(function (cardConfig) {
          var selection = ensureMultipleSelectionState(groupIndex, cardConfig);

          if (!selection.selected) {
            return;
          }

          var selectedVariant = getSelectedAddOnVariant(cardConfig, selection);

          if (!selectedVariant || !selectedVariant.id) {
            return;
          }

          var properties = {};

          if (state.isPublishedConfigurator) {
            properties._aerofoils_addon_parent = parentVariantId;
            properties._aerofoils_addon_group =
              entry.groupConfig.heading ||
              entry.groupConfig.option_name ||
              "Add-on";
            properties._aerofoils_addon_option =
              cardConfig.title || cardConfig.option_value || "Add-on";
          } else {
            properties._bundle_addon_parent_variant_id = parentVariantId;
            properties._bundle_addon_group =
              entry.groupConfig.heading ||
              entry.groupConfig.option_name ||
              "Add-on";
            properties._bundle_addon_option =
              cardConfig.title || cardConfig.option_value || "Add-on";
          }

          if (selection.sizeValue) {
            if (state.isPublishedConfigurator) {
              properties._aerofoils_addon_size = selection.sizeValue;
            } else {
              properties._bundle_addon_size = selection.sizeValue;
            }
          }

          result.push({
            id: selectedVariant.id,
            quantity: 1,
            properties: properties,
          });
        });

        return result;
      }, []);
    }

    var variantSkuMap = null;

    function getConfigVariantSku(variantId) {
      if (!variantSkuMap) {
        variantSkuMap = {};

        var addSku = function (id, sku) {
          if (id && sku && !variantSkuMap[String(id)]) {
            variantSkuMap[String(id)] = String(sku);
          }
        };

        groupConfigs.forEach(function (groupConfig) {
          ((groupConfig && groupConfig.cards) || []).forEach(function (cardConfig) {
            getCardComponents(cardConfig).forEach(function (component) {
              addSku(component && component.variant_id, component && component.sku);
            });
            getCardVariantChoices(cardConfig).forEach(function (choice) {
              addSku(choice && choice.id, choice && choice.sku);
            });
            ((cardConfig && cardConfig.product && cardConfig.product.variants) || []).forEach(
              function (variant) {
                addSku(variant && variant.id, variant && variant.sku);
              },
            );
          });
        });
      }

      return variantSkuMap[String(variantId || "")] || "";
    }

    /* Configured set for HubSpot forms opened from this section (inquiry,
     * notify me, …), read by assets/hubspot-form-modal.js and region-sales.js.
     * The published configurator keeps its selection off-DOM, and add-ons are
     * separate cart lines, so neither is visible to the form as inputs.
     * product_sku lists the component SKUs (the parent set SKU only stands for
     * the default configuration). */
    function buildInquiryContext() {
      var skuQuantities = {};
      var skuOrder = [];
      var addOnLabels = {};
      var addOnGroups = [];
      var addOnPayload = [];

      function addSku(variantId, quantity) {
        var sku = getConfigVariantSku(variantId);

        if (!sku) {
          return;
        }

        if (!skuQuantities[sku]) {
          skuQuantities[sku] = 0;
          skuOrder.push(sku);
        }

        skuQuantities[sku] += Number(quantity) > 0 ? Number(quantity) : 1;
      }

      state.renderedGroups.forEach(function (entry, groupIndex) {
        if (!entry || !entry.groupConfig) {
          return;
        }

        if (entry.mode === "multiple") {
          var groupLabel =
            entry.groupConfig.heading || entry.groupConfig.option_name || "Add-on";

          getVisibleCards(entry.groupConfig.cards).forEach(function (cardConfig) {
            var selection = ensureMultipleSelectionState(groupIndex, cardConfig);
            var selectedVariant = selection.selected
              ? getSelectedAddOnVariant(cardConfig, selection)
              : null;

            if (!selectedVariant || !selectedVariant.id) {
              return;
            }

            var cardLabel =
              cardConfig.title || cardConfig.option_value || "Add-on";

            if (!addOnLabels[groupLabel]) {
              addOnLabels[groupLabel] = [];
              addOnGroups.push(groupLabel);
            }

            addOnLabels[groupLabel].push(
              selection.sizeValue && cardLabel.indexOf(selection.sizeValue) === -1
                ? cardLabel + " (" + selection.sizeValue + ")"
                : cardLabel,
            );
            addOnPayload.push([
              entry.groupConfig.key || groupLabel,
              getCardKey(cardConfig),
              Number(selectedVariant.id),
            ]);
            addSku(selectedVariant.id, 1);
          });
          return;
        }

        if (entry.mode !== "source") {
          return;
        }

        var selectedCard = getSelectedCardForEntry(entry);

        if (!selectedCard) {
          return;
        }

        if (state.isPublishedConfigurator) {
          getPublishedCardRuntimeComponents(entry.groupConfig, selectedCard).forEach(
            function (component) {
              addSku(component.id, component.q);
            },
          );
          return;
        }

        getCardComponents(selectedCard).forEach(function (component) {
          addSku(component && component.variant_id, component && component.quantity);
        });
      });

      var display = buildPublishedDisplaySummary();
      var addOnDisplay = addOnGroups
        .map(function (groupLabel) {
          return groupLabel + ": " + addOnLabels[groupLabel].join(", ");
        })
        .join(" | ");
      var payload = buildPublishedSelectionPayload();

      if (payload && addOnPayload.length) {
        payload.a = addOnPayload;
      }

      return {
        product_configuration: [display, addOnDisplay].filter(Boolean).join(" | "),
        product_configuration_json:
          payload && payload.s.length ? JSON.stringify(payload) : "",
        product_sku: skuOrder
          .map(function (sku) {
            return skuQuantities[sku] > 1 ? skuQuantities[sku] + "x " + sku : sku;
          })
          .join(", "),
      };
    }

    section.aerofoilsBundleInquiryContext = buildInquiryContext;

    function setSubmitLoading(nextLoading) {
      if (
        window.AerofoilsCartUI &&
        typeof window.AerofoilsCartUI.setAddToCartButtonsState === "function"
      ) {
        window.AerofoilsCartUI.setAddToCartButtonsState(
          submitButtons,
          nextLoading ? "loading" : "default",
        );
        return;
      }

      submitButtons.forEach(function (submitButton) {
        submitButton.disabled = !!nextLoading;
        submitButton.classList.toggle("is-loading", !!nextLoading);
      });
    }

    function buildBundleItems() {
      var mainItem = buildMainBundleItem();

      if (!mainItem.id) {
        return [];
      }

      return [mainItem].concat(buildSelectedAddOnItems());
    }

    async function postBundleItems(items) {
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: items,
        }),
      });
      var payload = await response.json();

      if (!response.ok) {
        throw new Error(
          payload.description || payload.message || "Add to cart failed",
        );
      }

      return payload;
    }

    async function submitBundleWithAddOns(event) {
      if ((!state.hasMultipleGroups && !state.isPublishedConfigurator) || !form) {
        return;
      }

      if (event.defaultPrevented) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (state.isPublishedConfigurator) {
        try {
          await refreshPublishedRuntimeFromStorefront({
            force: true,
            syncUi: true,
          });
        } catch (error) {
          console.warn("Published runtime refresh failed before add to cart:", error);
        }
      }

      var items = buildBundleItems();

      if (!items.length) {
        return;
      }

      setSubmitLoading(true);

      try {
        await postBundleItems(items);

        if (
          window.AerofoilsCartUI &&
          typeof window.AerofoilsCartUI.refresh === "function"
        ) {
          await window.AerofoilsCartUI.refresh({ openDrawer: true });

          if (
            typeof window.AerofoilsCartUI.pulseHeaderCartTrigger === "function"
          ) {
            window.AerofoilsCartUI.pulseHeaderCartTrigger();
          }

          if (
            typeof window.AerofoilsCartUI.setAddToCartButtonsState ===
            "function"
          ) {
            window.AerofoilsCartUI.setAddToCartButtonsState(
              submitButtons,
              "success",
            );
            await new Promise(function (resolve) {
              window.setTimeout(resolve, 1200);
            });
          }
        } else {
          window.location.href = "/cart";
        }
      } catch (error) {
        console.error("Bundle add to cart error:", error);
      } finally {
        setSubmitLoading(false);
      }
    }

    section.aerofoilsBundleBuyNow = async function () {
      if (!form) {
        throw new Error("Bundle form not found");
      }

      if (!state.hasMultipleGroups && !state.isPublishedConfigurator) {
        var response = await fetch("/cart/add.js", {
          method: "POST",
          body: new FormData(form),
          headers: {
            Accept: "application/json",
          },
        });
        var payload = await response.json();

        if (!response.ok) {
          throw new Error(
            payload.description || payload.message || "Buy now failed",
          );
        }

        window.location.href = "/checkout";
        return payload;
      }

      if (state.isPublishedConfigurator) {
        try {
          await refreshPublishedRuntimeFromStorefront({
            force: true,
            syncUi: true,
          });
        } catch (error) {
          console.warn("Published runtime refresh failed before buy now:", error);
        }
      }

      var items = buildBundleItems();

      if (!items.length) {
        throw new Error("Bundle items not found");
      }

      await postBundleItems(items);
      window.location.href = "/checkout";
      return items;
    };

    function bindBundleSubmit() {
      if (
        (!state.hasMultipleGroups && !state.isPublishedConfigurator) ||
        !form ||
        section.dataset.bundleBoardSubmitBound === "true"
      ) {
        return;
      }

      section.dataset.bundleBoardSubmitBound = "true";
      form.dataset.aerofoilsBundleAddons = "true";
      form.addEventListener("submit", submitBundleWithAddOns);
    }

    function mountFromSource(options) {
      var settings = options || {};
      var sourceGroups = getSourceGroups(state.sourceRoot);

      if (!sourceGroups.length) {
        return false;
      }

      state.renderedGroups = buildRenderedGroups(sourceGroups);

      if (!state.renderedGroups.length) {
        return false;
      }

      initializeMultipleSelections();
      var defaultState = applySourceGroupDefaults();
      var presetState =
        settings.skipPreset === true
          ? { sourceGroupsChanged: false }
          : applyPresetSelections();

      state.sourceRoot.classList.add("product-page-section__bundle-source");

      setBundleRootReady();
      root.innerHTML = state.renderedGroups
        .map(function (entry, groupIndex) {
          return renderBundleGroupMarkup(
            entry,
            groupIndex,
            priceFormatter,
            section.id,
            labels,
            productOptionNames,
            hasParentBasePrice,
          );
        })
        .join("");

      logBundlePresetDebug();
      bindSourceSelects();
      bindBundleSubmit();
      syncFromSource();
      scheduleDeferredInteractiveFeatures();
      observeDeferredBelowFoldFeatures();
      state.sourceHydrationSignature = getSourceGroupsSignature(
        getSourceGroups(state.sourceRoot),
      );

      if (
        (defaultState && defaultState.sourceGroupsChanged) ||
        (presetState && presetState.sourceGroupsChanged)
      ) {
        window.requestAnimationFrame(function () {
          syncFromSource();
        });
      }

      return true;
    }

    function mountFromPublishedState(options) {
      var settings = options || {};

      state.sourceRoot = buildPublishedSourceRoot();

      if (!state.sourceRoot) {
        return false;
      }

      state.renderedGroups = buildRenderedGroups(getSourceGroups(state.sourceRoot));

      if (!state.renderedGroups.length) {
        return false;
      }

      initializeMultipleSelections();
      var defaultState = applySourceGroupDefaults();
      var presetState =
        settings.skipPreset === true
          ? { sourceGroupsChanged: false }
          : applyPresetSelections();

      setBundleRootReady();
      root.innerHTML = state.renderedGroups
        .map(function (entry, groupIndex) {
          return renderBundleGroupMarkup(
            entry,
            groupIndex,
            priceFormatter,
            section.id,
            labels,
            productOptionNames,
            hasParentBasePrice,
          );
        })
        .join("");

      logBundlePresetDebug();
      bindSourceSelects();
      bindBundleSubmit();
      syncFromSource();
      scheduleDeferredInteractiveFeatures();
      observeDeferredBelowFoldFeatures();

      refreshPublishedRuntimeFromStorefront({
        syncUi: true,
      }).catch(function (error) {
        console.warn("Published runtime refresh failed on mount:", error);
      });

      if (
        (defaultState && defaultState.sourceGroupsChanged) ||
        (presetState && presetState.sourceGroupsChanged)
      ) {
        window.requestAnimationFrame(function () {
          syncFromSource();
        });
      }

      return true;
    }

    function runSourceHydrationCheck() {
      var sourceGroups = null;
      var currentSignature = "";

      if (!state.sourceRoot) {
        stopSourceHydrationWatch();
        return;
      }

      if (state.hasUserInteractedWithBundle) {
        stopSourceHydrationWatch();
        return;
      }

      sourceGroups = getSourceGroups(state.sourceRoot);
      currentSignature = getSourceGroupsSignature(sourceGroups);

      if (
        currentSignature !== state.sourceHydrationSignature ||
        !isSourceUiReady()
      ) {
        mountFromSource({
          skipPreset: state.sourceHydrationAttempts > 0,
        });
      }

      if (isSourceUiReady()) {
        stopSourceHydrationWatch();
        return;
      }

      state.sourceHydrationAttempts += 1;

      if (state.sourceHydrationAttempts >= 20) {
        stopSourceHydrationWatch();
        return;
      }

      scheduleSourceHydrationCheck(180);
    }

    function startSourceHydrationWatch() {
      stopSourceHydrationWatch();

      if (!state.sourceRoot) {
        return;
      }

      state.sourceHydrationSignature = getSourceGroupsSignature(
        getSourceGroups(state.sourceRoot),
      );

      if (isSourceUiReady()) {
        return;
      }

      if (typeof MutationObserver === "function") {
        state.sourceHydrationObserver = new MutationObserver(function () {
          scheduleSourceHydrationCheck(0);
        });

        state.sourceHydrationObserver.observe(state.sourceRoot, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
        });
      }

      scheduleSourceHydrationCheck(180);
    }

    root.addEventListener("click", function (event) {
      var hintTrigger = event.target.closest("[data-bundle-hint-trigger]");
      var optionButton = event.target.closest("[data-bundle-option-button]");
      var modalOpenButton = event.target.closest("[data-bundle-modal-open]");
      var modalCloseButton = event.target.closest("[data-bundle-modal-close]");
      var addOnSizeButton = event.target.closest(
        "[data-bundle-addon-size-button]",
      );
      var addOnToggleButton = event.target.closest(
        "[data-bundle-addon-toggle]",
      );
      var addOnGuideLink = event.target.closest("[data-bundle-addon-guide]");
      var hintPopover = event.target.closest("[data-bundle-hint-popover]");
      var addOnCard = event.target.closest("[data-bundle-addon-card]");

      if (hintTrigger) {
        var hintRoot = hintTrigger.closest("[data-bundle-hint]");
        var isExpanded = hintTrigger.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
          setHintOpen(hintRoot, false);
          return;
        }

        closeHints(hintRoot);
        setHintOpen(hintRoot, true);
        return;
      }

      if (modalOpenButton) {
        ensureDeferredInteractiveFeatures();
        var dialogId = modalOpenButton.getAttribute("data-bundle-modal-open");
        openDialog(root.querySelector("#" + dialogId));
        return;
      }

      if (modalCloseButton) {
        closeDialog(modalCloseButton.closest("[data-bundle-modal]"));
        return;
      }

      if (addOnSizeButton) {
        state.hasUserInteractedWithBundle = true;
        ensureDeferredInteractiveFeatures({ skipSync: true });
        var sizeGroupIndex = Number(
          addOnSizeButton.getAttribute("data-bundle-group-index"),
        );
        var sizeRenderedGroup = state.renderedGroups[sizeGroupIndex];
        var sizeCardKey =
          addOnSizeButton.getAttribute("data-bundle-card-key") || "";
        var sizeCardConfig = findCardByKey(
          sizeRenderedGroup && sizeRenderedGroup.groupConfig
            ? sizeRenderedGroup.groupConfig.cards
            : [],
          sizeCardKey,
        );

        if (!sizeCardConfig || addOnSizeButton.disabled) {
          return;
        }

        var sizeSelection = ensureMultipleSelectionState(
          sizeGroupIndex,
          sizeCardConfig,
        );
        sizeSelection.variantId =
          addOnSizeButton.getAttribute("data-bundle-addon-variant-id") || "";
        sizeSelection.sizeValue =
          addOnSizeButton.getAttribute("data-bundle-addon-size-value") || "";
        syncFromSource();
        return;
      }

      if (addOnToggleButton) {
        state.hasUserInteractedWithBundle = true;
        ensureDeferredInteractiveFeatures({ skipSync: true });
        var toggleGroupIndex = Number(
          addOnToggleButton.getAttribute("data-bundle-group-index"),
        );
        var toggleRenderedGroup = state.renderedGroups[toggleGroupIndex];
        var toggleCardKey =
          addOnToggleButton.getAttribute("data-bundle-card-key") || "";
        var toggleCardConfig = findCardByKey(
          toggleRenderedGroup && toggleRenderedGroup.groupConfig
            ? toggleRenderedGroup.groupConfig.cards
            : [],
          toggleCardKey,
        );

        if (
          !toggleCardConfig ||
          addOnToggleButton.disabled ||
          !hasAvailableAddOnChoice(toggleCardConfig)
        ) {
          return;
        }

        var toggleSelection = ensureMultipleSelectionState(
          toggleGroupIndex,
          toggleCardConfig,
        );
        toggleSelection.selected = !toggleSelection.selected;
        syncFromSource();
        return;
      }

      if (addOnGuideLink) {
        return;
      }

      if (hintPopover) {
        return;
      }

      if (addOnCard && !event.target.closest("button, a")) {
        state.hasUserInteractedWithBundle = true;
        ensureDeferredInteractiveFeatures({ skipSync: true });
        var cardGroupIndex = Number(
          addOnCard.getAttribute("data-bundle-group-index"),
        );
        var cardRenderedGroup = state.renderedGroups[cardGroupIndex];
        var cardKey = addOnCard.getAttribute("data-bundle-card-key") || "";
        var cardConfig = findCardByKey(
          cardRenderedGroup && cardRenderedGroup.groupConfig
            ? cardRenderedGroup.groupConfig.cards
            : [],
          cardKey,
        );

        if (!cardConfig || !hasAvailableAddOnChoice(cardConfig)) {
          return;
        }

        var cardSelection = ensureMultipleSelectionState(
          cardGroupIndex,
          cardConfig,
        );
        cardSelection.selected = !cardSelection.selected;
        syncFromSource();
        return;
      }

      if (!optionButton || !state.sourceRoot) {
        return;
      }

      var groupIndex = Number(
        optionButton.getAttribute("data-bundle-group-index"),
      );
      var nextValue = optionButton.getAttribute("data-bundle-value") || "";
      var renderedGroup = state.renderedGroups[groupIndex];
      var sourceGroup =
        renderedGroup && renderedGroup.mode === "source"
          ? renderedGroup.group
          : null;

      if (!sourceGroup || optionButton.disabled) {
        return;
      }

      state.hasUserInteractedWithBundle = true;
      ensureDeferredInteractiveFeatures({ skipSync: true });
      setSourceGroupValue(sourceGroup, nextValue);
      window.requestAnimationFrame(syncFromSource);
    });

    root.addEventListener("click", function (event) {
      var dialog = event.target.closest("[data-bundle-modal]");

      if (dialog && event.target === dialog) {
        closeDialog(dialog);
      }
    });

    document.addEventListener("click", function (event) {
      if (!root.contains(event.target)) {
        closeHints();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }

      closeHints();
      closeAllModals();
    });

    function tryMountFromSource() {
      state.sourceRoot = findSourceRoot();

      if (state.sourceRoot && mountFromSource()) {
        startSourceHydrationWatch();
        return true;
      }

      return false;
    }

    function tryMountPublishedState() {
      if (!state.isPublishedConfigurator) {
        return false;
      }

      return mountFromPublishedState();
    }

    section.aerofoilsBundleBoardCleanup = function () {
      stopSourceHydrationWatch();

      if (includedGridObserver) {
        includedGridObserver.disconnect();
        includedGridObserver = null;
      }

      if (includedResizeHandler) {
        window.removeEventListener("resize", includedResizeHandler);
        includedResizeHandler = null;
      }

      if (state.includedCollapseFrame) {
        window.cancelAnimationFrame(state.includedCollapseFrame);
        state.includedCollapseFrame = 0;
      }

      if (state.deferredBelowFoldCleanupFns.length) {
        state.deferredBelowFoldCleanupFns.forEach(function (cleanup) {
          if (typeof cleanup === "function") {
            cleanup();
          }
        });
        state.deferredBelowFoldCleanupFns = [];
      }
    };

    if (tryMountPublishedState()) {
      return;
    }

    if (tryMountFromSource()) {
      return;
    }

    if (!document.body || typeof MutationObserver !== "function") {
      return;
    }

    var sourceObserver = new MutationObserver(function () {
      if (tryMountFromSource()) {
        sourceObserver.disconnect();
      }
    });

    sourceObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (
    window.Aerofoils &&
    typeof window.Aerofoils.registerSection === "function"
  ) {
    window.Aerofoils.registerSection({
      guardKey: "bundleBoardProductInit",
      selector: "[data-bundle-board]",
      init: initBundleBoardSection,
      destroy: function () {},
    });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      var sections = document.querySelectorAll("[data-bundle-board]");
      sections.forEach(initBundleBoardSection);
    });
  }
})();

(function () {
  var mobileQuery = window.matchMedia
    ? window.matchMedia("(max-width: 767px)")
    : null;
  var lastScrollY = window.scrollY || 0;
  var ticking = false;
  var scrollThreshold = 12;
  var topOffset = 24;

  function getStickyShells() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        ".product-page-section--bundle-board .product-page-section__sticky-shell",
      ),
    );
  }

  function isMobile() {
    return !mobileQuery || mobileQuery.matches;
  }

  function setStickyVisible(visible) {
    var hasVisibleStickyBar = false;

    getStickyShells().forEach(function (stickyShell) {
      stickyShell.classList.toggle("is-scroll-visible", visible);

      if (visible) {
        hasVisibleStickyBar = true;
      }
    });

    document.body.classList.toggle(
      "bundle-product-sticky-bar-is-visible",
      hasVisibleStickyBar && isMobile(),
    );
  }

  function syncBundleStickyBar() {
    var currentScrollY = window.scrollY || 0;
    var scrollingDown = currentScrollY > lastScrollY;
    var scrollDelta = Math.abs(currentScrollY - lastScrollY);

    if (!isMobile() || currentScrollY <= topOffset) {
      setStickyVisible(false);
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    if (scrollDelta >= scrollThreshold) {
      setStickyVisible(scrollingDown);
      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  function requestStickySync() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(syncBundleStickyBar);
  }

  function resetStickyBar() {
    lastScrollY = window.scrollY || 0;
    syncBundleStickyBar();
  }

  window.addEventListener("scroll", requestStickySync, { passive: true });
  window.addEventListener("resize", resetStickyBar);
  document.addEventListener("shopify:section:load", resetStickyBar);
  document.addEventListener("DOMContentLoaded", resetStickyBar);

  if (mobileQuery) {
    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", resetStickyBar);
    } else if (typeof mobileQuery.addListener === "function") {
      mobileQuery.addListener(resetStickyBar);
    }
  }

  resetStickyBar();
})();
